export const common = {
  // Top Bar
  topBar: {
    freeShipping: 'ÜCRETSİZ KARGO - Tüm Siparişlerde',
    newMemberDiscount: 'Yeni üyelere %10 indirim',
    securePayment: 'Güvenli Alışveriş',
  },

  // Header
  header: {
    shopNow: 'Hemen Alışveriş Yap',
  },

  // Navigation
  nav: {
    home: 'Ana Sayfa',
    women: 'KADIN',
    men: 'ERKEK',
    blog: 'BLOG',
    superSale: 'SÜPER İNDİRİM',
    memberLogin: 'ÜYE GİRİŞİ',
    login: 'Giriş Yap',
    register: 'ÜYE OL',
    myOrders: 'Siparişlerim',
    myFavorites: 'Favorilerim',
    myCart: 'Sepetim',
    pages: 'Sayfalar',
    preferences: 'Tercihler',
    myProfile: 'Profilim',
  },

  // Mega Menu
  megaMenu: {
    womenCollection: 'Kadın Koleksiyonu',
    menCollection: 'Erkek Koleksiyonu',
    summerCollection: '2025 Yaz Koleksiyonu',
    viewAll: 'Tümünü Gör',
    categories: 'KATEGORİLER',
    newSeason: 'YENİ SEZON',
    upToDiscount: '%70\'e varan indirim',
    exploreAll: 'Tüm koleksiyonu keşfet',
    viewAllBtn: 'Tümünü Gör',
    securePayment: 'Güvenli Ödeme',
    sslNote: 'Tüm ödemeleriniz şifreli ve güvende.',
    sslBadge: '256-bit SSL',
    quickTags: {
      newArrivals: 'Yeni Gelenler',
      bestSelling: 'En Çok Satan',
      discounted: 'İndirimli',
      specialDesign: 'Özel Tasarım',
    },
    // Women categories
    womenSandals: 'Kadın Sandalet',
    womenSandalsDesc: 'Yaz koleksiyonu',
    womenClothing: 'Kadın Giyim',
    womenClothingDesc: 'Trend parçalar',
    womenShoes: 'Kadın Ayakkabı',
    womenShoesDesc: 'Her tarza uygun',
    womenBoots: 'Kadın Bot',
    womenBootsDesc: 'Şık & sağlam',
    womenSlippers: 'Kadın Terlik',
    womenSlippersDesc: 'Rahat & şık',
    womenBags: 'Kadın Çanta',
    womenBagsDesc: 'Sezon favorileri',
    womenAccessories: 'Kadın Aksesuar',
    womenAccessoriesDesc: 'Tamamlayıcı parçalar',
    womenCombo: 'Kadın Kombin',
    womenComboDesc: 'Komple setler',
    // Men categories
    menSandals: 'Erkek Sandalet',
    menSandalsDesc: 'Yaz koleksiyonu',
    menClothing: 'Erkek Giyim',
    menClothingDesc: 'Modern stiller',
    menShoes: 'Erkek Ayakkabı',
    menShoesDesc: 'Klasik & spor',
    menBoots: 'Erkek Bot',
    menBootsDesc: 'Güçlü & şık',
    menSlippers: 'Erkek Terlik',
    menSlippersDesc: 'Günlük konfor',
    menBags: 'Erkek Çanta',
    menBagsDesc: 'İş & günlük',
    menAccessories: 'Erkek Aksesuar',
    menAccessoriesDesc: 'Tarz detaylar',
    menCombo: 'Erkek Kombin',
    menComboDesc: 'Komple setler',
    comboBadge: 'Kombin',
    // Sub categories
    tshirt: 'Tişört',
    pants: 'Pantolon',
    dress: 'Elbise',
    kimono: 'Kimono',
    crop: 'Crop',
    shirt: 'Gömlek',
    skirt: 'Etek',
    shorts: 'Şort',
    suit: 'Takım',
    set: 'Set',
    // Collection label
    womenLabel: 'Kadın',
    menLabel: 'Erkek',
    collectionSuffix: 'Koleksiyonu',
  },

  // Top Bar Messages
  topBarMessages: {
    msg1: 'ÜCRETSİZ KARGO - Tüm Siparişlerde | Yeni üyelere %10 indirim',
    msg2: 'ORGANİC TOPRAKLAMA BAREFOOT AYAKKABI BOTLAR SANDALETLER',
    msg3: 'ORGANİC MODAYI HAYATA UYGULAMA ZAMANI — DOĞALLIĞI KEŞFET',
    msg4: 'SÜPER KOMBİNLER — SÜRPRİZ HEDİYELERİ KAÇIRMA STOK BİTMEDEN AL',
  },

  // Quick Menu / Help Popup
  quickMenu: {
    title: 'Hızlı Erişim',
    liveChat: 'Canlı Chat',
    liveChatStatus: 'Şu an aktif ✓',
    liveCall: 'Canlı Konuşma',
    liveCallDesc: 'Sesli destek',
    liveBroadcast: 'Canlı Yayın',
    liveBroadcastStatus: 'Şu an yayında 🔴',
    liveBroadcastBadge: 'CANLI',
    sustainability: 'Sürdürülebilirlik',
    sustainabilityDesc: '%100 Organik 🌿',
    support247: '7/24 Müşteri Desteği',
    scrollUp: 'Yukarı Kaydır',
    menu: 'MENÜ',
    up: 'YUKARI',
    dayMode: 'Gündüz',
    nightMode: 'Gece',
    liveSupport: 'Canlı Destek',
    liveSupportStatus: 'Şu an aktif',
    socialMedia: 'Sosyal Medya',
    pages: 'Sayfalar',
    support: 'Destek',
    followUs: 'Bizi Takip Et',
    wholesale: 'Toptan Ürünler',
  },

  // Popular Products nav link
  popularProductsNav: 'Popüler Ürünler',

  // Settings
  settings: {
    language: 'Dil',
    currency: 'Para Birimi',
    selectLanguage: 'Dil Seçin',
    selectCurrency: 'Para Birimi Seçin',
  },

  // Mobile Marquee
  marquee: {
    discount: '%70 İNDİRİM',
    combos: 'KOMBİNLERDE',
    summer: 'YAZA ÖZEL',
  },

  // Home Page
  home: {
    bestSeller: 'ÇOK SATAN',
    specialCampaign: 'ÖZEL KAMPANYA',
    featuredCombos: 'Öne Çıkan Kombin Setleri',
    featuredProducts: 'Öne Çıkan Ürünler',
    exploreCategories: 'Kategorileri Keşfet',
    viewAllProducts: 'Tüm Ürünleri Gör',
    viewAllCombos: 'Tüm Kombinleri Gör',
    setContent: 'SET İÇERİĞİ',
    normalPrice: 'Normal Fiyat',
    comboPrice: 'Kombin Fiyatı',
    save: 'TASARRUF',
    freeShippingBadge: 'Ücretsiz Kargo',
    viewDetails: 'Detayları Gör',
    // Where To Next
    whereToNextLabel: 'Koleksiyonlar',
    whereToNextTitle: 'Sıradaki Durağın?',
    whereToNextSubtitle: 'Seyahatine götüreceğin tek ayakkabı!',
    whereToNextShop: 'Ürünü Gör',
    whereToNextBuy: 'HEMEN AL',
    // Flash Sale
    flashSaleLabel: 'Flaş İndirim',
    flashSaleTitle: '%70\'e Varan Kampanya Fırsatları',
    flashSaleSubtitle: 'Sınırlı stok — kaçırmadan al!',
    flashSaleViewAll: 'Tümünü Gör',
    flashSaleTimeLabel: 'Kampanya Bitimine',
    flashSaleHour: 'Saat',
    flashSaleMinute: 'Dakika',
    flashSaleSecond: 'Saniye',
    flashSaleNext: 'Sonraki:',
    flashSaleRound: 'Tur',
    flashSaleStockRunning: 'Stok Tükeniyor',
    flashSaleSold: 'Satıldı',
    flashSaleBuy: 'Hemen Al',
    flashSaleNewCampaign: 'Yeni Kampanya Başladı!',
    flashSaleNewCampaignSub: 'Kaçırma!',
    // Combo Packs
    comboPacksTitle: 'Kombin Paketler',
    comboPacksSubtitle: 'Hazır kombinlerle zamandan ve paradan tasarruf edin',
    comboPacksIn: 'Pakette:',
    comboPacksSaving: 'tasarruf!',
    comboPacksViewAll: 'Tüm Kombinleri Gör',
    // Explore Categories
    exploreCategoriesLabel: 'Koleksiyonlar',
    exploreCategoriesSubtitle: 'Tarzınıza uygun koleksiyonu seçin',
    // Category Cards
    catSlippers: 'Terlik',
    catSlippersSub: 'Rahat & Şık Modeller',
    catSandals: 'Sandalet',
    catSandalsSub: 'Topuklu & Düz Modeller',
    catCombos: 'Kombinler',
    catCombosSub: "1+1 $500'dan Başlayan Fiyatlar",
    catDresses: 'Elbiseler',
    catDressesSub: 'Maxi, Midi & Mini Modeller',
    catVeganLeather: 'Vegan Deri',
    catVeganLeatherSub: 'Cruelty-Free Koleksiyon',
    catGenuineLeather: 'Gerçek Deri',
    catGenuineLeatherSub: 'Premium Hayvan Derisi Ürünler',
    catBadgeVegan: 'VEGAN',
    catBadgePremium: 'PREMİUM',
    // Categories Section
    categoriesSubtitle: 'Size uygun kategoriyi seçin',
    // Recent Reviews
    recentReviewsTitle: 'Son Müşteri Yorumları',
    recentReviewsSubtitle: 'Gerçek alıcılardan en güncel değerlendirmeler',
    recentReviewsViewAll: 'Tüm Yorumlar',
    recentReviewsAvgScore: 'Ortalama Puan',
    recentReviewsTotal: 'Toplam Yorum',
    recentReviewsVerified: 'Doğrulanmış Alıcı',
    recentReviewsVerifiedBadge: 'Doğrulanmış',
    recentReviewsSizeLabel: 'Beden:',
    // Spring Banner
    springBannerSubtitle: 'Yeni sezon koleksiyonlarını keşfedin ve stilinizi tamamlayın',
    springCollectionsLabel: 'Koleksiyonlar',
    // Video Banner
    videoBannerLabel: 'Müşteri Favorileri',
    videoBannerTitle: 'En Çok Beğenilen Ürünler',
    videoBannerSubtitle: 'En çok beğenilen ve değerlendirilen ürünlerimiz',
    videoBannerViewAll: 'Tüm Sayfayı Gör',
    videoBannerCta: 'Sürdürülebilirlik Felsefemizi Keşfet',
    videoBannerCertsLabel: 'Sertifikalarımız',
    videoBannerCarbonLabel: 'Karbon Ayak İzi',
    videoBannerCarbonVal: 'Sıfır Emisyon',
    // Hero
    heroStartingFrom: 'Başlayan Fiyatlarla',
    // Blog Preview
    blogBadge: 'Blog',
    blogTitle: 'Son Yazılarımız',
    blogSubtitle: 'Sağlık, moda ve sürdürülebilirlik üzerine ilham verici içerikler',
    blogViewAll: 'Tüm Yazıları Gör',
    blogReadMore: 'Devamını Oku',
    blogReadTime: 'dk okuma',
    // Sustainability Banner
    sustBannerBadge: 'Sürdürülebilir Moda',
    sustBannerTitle: 'Sürdürülebilirlik & Organik Ürün',
    sustBannerTitleHighlight: 'Destekçisiyiz',
    sustBannerDesc: 'Her dikişimiz, her boyamız, her malzememiz — gezegenimize ve size duyduğumuz saygının ifadesidir. GOTS sertifikalı organik pamuktan bitkisel boyalarla renklendirilen her parça, doğanın renk paletinden ilham alır. El işçiliğiyle hayat bulan her ürün, bir ustanın yüzyıllık bilgeliğini ve sanatını yansıtır.',
    sustBannerStat1Label: 'Daha Az Su',
    sustBannerStat2Label: 'Organik Malzeme',
    sustBannerStat3Label: 'Kimyasal Boya',
    sustBannerStat4Label: 'El Yapımı Ürün',
    sustBannerCta1: 'Sürdürülebilirlik Sayfamız',
    sustBannerCta2: 'Organik Koleksiyon',
    // Sustainability Preview
    sustPreviewBadge: 'Sürdürülebilirlik',
    sustPreviewTitle: 'Doğadan Gelen,',
    sustPreviewTitleHighlight: 'Doğaya Dönen',
    sustPreviewSubtitle: 'Her malzeme, her üretim adımı ve her ambalajımız çevre ve insan sağlığına duyduğumuz saygının kanıtıdır.',
    sustPreviewViewAll: 'Tüm Sayfayı Gör',
    sustPreviewCta: 'Sürdürülebilirlik Felsefemizi Keşfet',
    sustPreviewCertsLabel: 'Sertifikasyonlarımız',
    sustPreviewCarbonLabel: 'Karbon Ayak İzi',
    sustPreviewCarbonVal: 'Sıfır Emisyon',
    // PC Slider
    pcSlide1Tag: '⚡ YENİ KOLEKSİYON',
    pcSlide1Title: 'Yaz Rüyası',
    pcSlide1TitleHighlight: 'Koleksiyonu',
    pcSlide1Subtitle: "Akdeniz'in sıcaklığını ayaklarınıza taşıyan premium deri sandaletler",
    pcSlide2Tag: '🔥 %70 İNDİRİM',
    pcSlide2Title: 'Boho Chic',
    pcSlide2TitleHighlight: 'Yazlık Elbiseler',
    pcSlide2Subtitle: 'Özgür ruhunuzu yansıtan el yapımı boho koleksiyonu — sınırlı stok',
    pcSlide3Tag: '🌿 VEGAN DERİ',
    pcSlide3Title: 'Sürdürülebilir',
    pcSlide3TitleHighlight: 'Lüks Moda',
    pcSlide3Subtitle: 'Doğaya saygılı, cruelty-free premium vegan deri koleksiyonu',
    pcSlide4Tag: '🍂 YENİ KOLEKSİYON',
    pcSlide4Title: 'Sonbahar',
    pcSlide4TitleHighlight: 'Bot Koleksiyonu',
    pcSlide4Subtitle: 'El yapımı premium deri botlarla sonbaharın ruhunu hissedin — sınırlı stok',
    pcSlide4Cta1: 'Kadın Bot',
    pcSlide4Cta2: 'Erkek Bot',
    // Mobile Slider
    mobileSlide1Title: 'Yaz Modası %65 İndirim',
    mobileSlide1Subtitle: "Yaz Kombinlerinde %70'e Varan İndirimler",
    mobileSlide2Title: 'Yeni Koleksiyon',
    mobileSlide2Subtitle: 'Premium Deri Sandalet & Terlik Modelleri',
    mobileSlide3Title: 'Sonbahar Koleksiyonu',
    mobileSlide3Subtitle: 'El Yapımı Deri Çizmeler — Sınırlı Stok',
    // Promo Banner
    promoTitle: '1+1 Kombinlerde',
    promoTitleHighlight: '%70 İNDİRİM',
    promoSavings: '$1.800 TASHARRUF EDIN!',
    promoCta: 'Kombinleri Keşfet',
    promoDiscountBadge: '%70 TASHARRUF',
    // Square Banners
    squareBanner1Label: 'YENİ KOLEKSİYON',
    squareBanner1Title: 'Yazlık\nKoleksiyon',
    squareBanner2Label: 'EN ÇOK SATAN',
    squareBanner2Title: 'Terlik\nKoleksiyonu',
    squareBanner3Label: 'YAZ TRENDİ',
    squareBanner3Title: 'Sandalet\nKoleksiyonu',
    squareBanner4Label: 'SONBAHAR',
    squareBanner4Title: 'Bot\nKoleksiyonu',
    // Editorial Banners
    editorialBannersLabel: 'Koleksiyonlarımız',
    editorialBannersTitle: 'Sabah Season is Coming',
    editorialBanner2Label: 'En Çok Satan',
    editorialBanner2Title: 'Pattern Babas',
    editorialBanner2Subtitle: 'İlkbahar Koleksiyonu',
    editorialBanner3Label: 'Seyahat',
    editorialBanner3Title: 'Sıradaki Durağın?',
    editorialBanner3Subtitle: "O'ahu'nun Kuzey Kıyısı",
    editorialBanner4Label: 'El Yapımı',
    editorialBanner4Title: 'The Lido Sandal',
    editorialBanner4Subtitle: 'İtalya\'da El Yapımı',
  },

  // Footer
  footer: {
    categories: 'Kategoriler',
    customerService: 'Müşteri Hizmetleri',
    followUs: 'Bizi Takip Edin',
    wholesale: 'Toptan Satış',
    aboutUs: 'Hakkımızda',
    contact: 'İletişim',
    faq: 'Sıkça Sorulan Sorular',
    returnPolicy: 'İade Politikası',
    privacyPolicy: 'Gizlilik Politikası',
    termsOfService: 'Kullanım Şartları',
    shippingInfo: 'Kargo Bilgileri',
    paymentMethods: 'Ödeme Yöntemleri',
    tagline: 'Yaz modasında öncü, kaliteli ve şık ürünlerle stilinizi tamamlayın.',
    womenClothing: 'Kadın Giyim',
    womenShoes: 'Kadın Ayakkabı',
    menClothing: 'Erkek Giyim',
    menShoes: 'Erkek Ayakkabı',
    comboPacks: 'Kombin Paketler',
    reviews: 'Yorumlar',
    videos: 'Videolar',
    popularProducts: 'Popüler Ürünler',
    sustainability: 'Sürdürülebilirlik',
    followUsDesc: 'Yeni koleksiyonlar ve kampanyalardan haberdar olun.',
    copyright: '© 2024 FentyBarefoot. Tüm hakları saklıdır.',
    features: 'ÖZELLİKLER',
    featuresNew: 'YENİ',
    sustainabilityLabel: 'SÜRDÜRÜLEBİLİRLİK',
    reviewsLabel: 'YORUMLAR',
    reviewsNew: 'YENİ',
    videosLabel: 'VİDEOLAR',
    videosNew: 'YENİ',
    returns: 'İade & Değişim',
    sslShopping: 'SSL ile güvenli alışveriş',
    women: 'Kadın',
    men: 'Erkek',
    company: 'Kurumsal',
    womenSandals: 'Kadın Sandalet',
    womenBoots: 'Kadın Bot',
    womenSlippers: 'Kadın Terlik',
    womenBags: 'Kadın Çanta',
    womenAccessories: 'Kadın Aksesuar',
    womenCombo: 'Kadın Kombin',
    menSandals: 'Erkek Sandalet',
    menBoots: 'Erkek Bot',
    menSlippers: 'Erkek Terlik',
    menBags: 'Erkek Çanta',
    menAccessories: 'Erkek Aksesuar',
    menCombo: 'Erkek Kombin',
    termsConditions: 'Kullanım Koşulları',
    privacyCookiePolicy: 'Gizlilik & Çerez Pol.',
    deliveryShipping: 'Teslimat ve Kargo',
    returnsExchanges: 'İade ve Değişim',
    allCategories: 'Tüm Kategoriler',
    addressesTitle: 'Ofislerimiz',
    trOfficeName: 'Türkiye Merkez',
    trOfficeAddrLine1: 'Şehitkamil Mahallesi, İpek Yolu Caddesi No: 127/A, Şehitkamil',
    trOfficeAddrLine2: '27500 Gaziantep, Türkiye',
    trTaxNo: 'Vergi No: 1234567890',
    usOfficeName: 'USA Office',
    usOfficeAddrLine1: '1234 Broadway Avenue, Suite 500',
    usOfficeAddrLine2: 'New York, NY 10001, United States',
    usTaxId: 'Tax ID: 98-7654321',
    returnPolicyBtn: 'İade & Değişim',
    sitemap: 'Site Haritası',
    securePaymentTitle: 'Güvenli Ödeme',
    shippingPartnerTitle: 'Kargo Partneri',
    fastDelivery: 'Hızlı Teslimat',
    securityTitle: 'Güvenlik',
    encryptedShopping: 'Şifreli Alışveriş',
    httpsSecure: 'HTTPS Güvenli',
    intlShippingTitle: 'Ülkeye Uluslararası Gönderim',
    intlShippingDesc: 'Tüm dünyaya hızlı ve güvenli teslimat — sipariş takibi dahil',
    cargoPartner: 'Kargo Ortağı',
    countries: 'Ülke',
    businessDaysLabel: 'İş Günü',
    trackingLabel: 'Takip',
    marketplaceTitle: 'Uluslararası Pazar Yerlerinde Satıyoruz',
    mobileShippingTitle: 'Ülkeye Güvenli Gönderim',
    mobileShippingSubtitle: 'Sipariş takibi · 3–7 iş günü',
    mobileCargo: 'Kargo',
    mobileMarketplaceTitle: 'Uluslararası Pazar Yerleri',
    newsletterTitle: 'Bültenimize Abone Olun',
    newsletterSubtitle: 'Yeni koleksiyonlar, özel kampanyalar ve ilk fırsatlardan haberdar olun.',
    newsletterPlaceholder: 'E-posta adresinizi girin',
    newsletterSubscribe: 'Abone Ol',
    newsletterSuccess: 'Teşekkürler! Başarıyla abone oldunuz. 🎉',
    newsletterPrivacy: 'Kişisel verileriniz güvende. İstediğiniz zaman abonelikten çıkabilirsiniz.',
  },

  // Category Page
  category: {
    filter: 'Filtrele',
    productsFound: 'ürün bulundu',
    page: 'Sayfa',
    otherCategories: 'Diğer Kategoriler',
    showingProducts: 'ürün gösteriliyor',
    of: '/',
    subcat: {
      all: 'Tümü',
      boots: 'Bot',
      clothing: 'Giyim',
      shoes: 'Ayakkabı',
      sandals: 'Sandalet',
      slippers: 'Terlik',
      bags: 'Çanta',
      accessories: 'Aksesuar',
      combo: 'Kombin Setleri',
      tshirt: 'Tişört',
      pants: 'Pantolon',
      dress: 'Elbise',
      kimono: 'Kimono',
      crop: 'Crop',
      shirt: 'Gömlek',
      skirt: 'Etek',
      shorts: 'Şort',
      suit: 'Takım',
    },
    meta: {
      women: 'Kadın',
      womenClothing: 'Kadın Giyim',
      womenSandals: 'Kadın Sandalet',
      womenSlippers: 'Kadın Terlik',
      womenShoes: 'Kadın Ayakkabı',
      womenBags: 'Kadın Çanta',
      womenAccessories: 'Kadın Aksesuar',
      womenBoots: 'Kadın Bot',
      womenCombo: 'Kadın Kombin Setleri',
      tshirt: 'Tişört',
      pants: 'Pantolon',
      dress: 'Elbise',
      kimono: 'Kimono',
      crop: 'Crop',
      shirt: 'Gömlek',
      skirt: 'Etek',
      shorts: 'Şort',
      suit: 'Takım',
      men: 'Erkek',
      menClothing: 'Erkek Giyim',
      menSandals: 'Erkek Sandalet',
      menSlippers: 'Erkek Terlik',
      menShoes: 'Erkek Ayakkabı',
      menBags: 'Erkek Çanta',
      menAccessories: 'Erkek Aksesuar',
      menBoots: 'Erkek Bot',
      menCombo: 'Erkek Kombin Setleri',
      menTshirt: 'Erkek Tişört',
      menPants: 'Erkek Pantolon',
      menShirt: 'Erkek Gömlek',
      menShorts: 'Erkek Şort',
      menSuit: 'Erkek Takım',
      veganLeather: 'Vegan Deri',
      genuineLeather: 'Gerçek Deri',
      combo: 'Kombinler',
    },
  },

  // Product Page
  productPage: {
    notFound: 'Ürün Bulunamadı',
    backToHome: 'Ana Sayfaya Dön',
    reviews: 'değerlendirme',
    inStock: 'Stokta Var',
    save: 'Tasarruf',
    comboContent: 'Kombin İçeriği',
    youSave: 'tasarruf ediyorsunuz',
    selectSize: 'Beden Seçin',
    sizeGuide: 'Beden Rehberi',
    shoeSize: 'Numara Seçin',
    shoeSizeGuide: 'Numara Rehberi',
    quantity: 'Adet',
    addToCart: 'Sepete Ekle',
    added: 'Eklendi!',
    selectOptions: 'Seçim Yapın!',
    buyNow: 'Hemen Al',
    freeShipping: 'Ücretsiz Kargo',
    dayReturn: '30 Gün İade',
    securePayment: 'Güvenli Ödeme',
    productDescription: 'Ürün Açıklaması',
    features: 'Özellikler',
    similarProducts: 'Benzer Ürünler',
    zoom: 'Yakınlaştır',
    zoomHint: 'Çift tıkla veya kaydır ile yakınlaştır',
    shopAnywhere: 'Bu ürünü istediğin yerden satın al',
    customerReviews: 'Müşteri Yorumları',
    addedToCart: 'Ürün sepete eklendi!',
    viewCart: 'Sepeti Gör',
    home: 'Ana Sayfa',
    personalization: 'Kişiselleştirme & Hediye Paketi',
    personalizationNote: 'Not ekle, hediye paketi seç',
    personalizationActive: 'Aktif',
    shippingOption: 'Kargo Seçeneği',
    freeShippingLabel: 'Ücretsiz Kargo',
    freeLabel: 'ÜCRETSİZ',
    estimatedDelivery: 'Tahmini teslimat:',
    businessDays: '(6 iş günü)',
    customsTax: 'Gümrük vergisi:',
    noExtraFee: 'Ekstra ödeme yok, tüm vergiler dahil!',
    missingSelection: 'Lütfen aşağıdaki seçimleri yapın:',
    notSelected: 'seçilmedi',
    discount: 'İNDİRİM',
    freeShippingBadge: 'ÜCRETSİZ KARGO',
    selectColor: 'Renk Seçin',
    sole: 'Sole',
    selectOption: 'Select an option',
    selected: 'Seçilen:',
    women: 'Kadın',
    men: 'Erkek',
    selectNumber: 'Bir numara seçin',
    bestSellers: 'En Çok Satan Ürünler',
    bestSellersSubtitle: 'Bu haftanın yıldızları',
    watchVideo: 'Videoyu İzle',
    closeEsc: 'ESC tuşuna basarak kapatabilirsiniz',
    featureList: [
      'Premium kalite malzeme',
      'Rahat kesim ve kullanım',
      'Uzun ömürlü dayanıklılık',
      'Kolay bakım ve temizlik',
      'Çeşitli beden seçenekleri',
    ],
    descriptionText1: 'Yaz koleksiyonumuzun öne çıkan parçalarından biri olan bu ürün, şıklığı ve konfortu bir araya getiriyor. Yüksek kaliteli malzemelerden üretilen ürünümüz, uzun ömürlü kullanım için özenle tasarlandı.',
    descriptionText2: 'Günlük kullanıma uygun olan bu ürün, hem rahat hem de şık bir görünüm sunar. Farklı kombinlerle kullanabileceğiniz bu parça, gardırobunuzun vazgeçilmezi olacak.',
    featuresTitle: 'Özellikler',
    notSureAboutSize: 'Beden emin değil misiniz?',
    fitOption: 'Kalıp Seçeneği',
    wideFitLabel: 'Geniş Kalıp',
    wideFitDesc: 'Rahat & bol kesim',
    narrowFitLabel: 'Dar Kalıp',
    narrowFitDesc: 'Fitted & slim kesim',
    personalizationInlineTitle: 'Kişiselleştirme',
    personalizationInlineLine1: 'Çorapsız giyilebilir, rahat ve sağlıklı.',
    personalizationInlineLine2: 'Doğru ölçüm için yalın ayak ölçünüzü (uzunluk ve genişlik) santimetre cinsinden bu alana yazabilirsiniz. Örnek (24.5 CM x 9 CM)',
    personalizationInlineLine3: 'İstediğinize göre geniş veya dar üretilecektir.',
  },

  // Super Sale Page
  superSale: {
    limitedTime: 'Sınırlı Süre Kampanyası',
    live: 'CANLI',
    timeRemaining: 'Kampanyaın Bitimine Kalan Süre',
    all: 'Tümü',
    women: 'Kadın',
    men: 'Erkek',
    womenCombo: 'Kadın Kombin',
    menCombo: 'Erkek Kombin',
    sortBy: 'Sırala',
    priceAsc: 'Fiyat: Düşükten Yükseğe',
    priceDesc: 'Fiyat: Yüksekten Düşüğe',
    discountDesc: 'İndirim: Yüksekten Düşüğe',
    newest: 'En Yeni',
    productsOnSale: 'İndirimli Ürün',
    totalDiscount: 'Toplam İndirim',
    happyCustomers: 'Mutlu Müşteri',
    freeShipping: 'Ücretsiz Kargo',
    banner1Title: 'Sezonun En İyi Fırsatları',
    banner1Subtitle: 'Tüm kategorilerde %70\'e varan indirimler',
    banner2Title: 'Son Saatler!',
    banner2Subtitle: 'Kaçırmadan sepetine ekle',
    // Countdown
    flashRound: 'Flaş İndirim',
    flashBadge: '⚡ FLAŞ',
    dailyRound: 'Günün Fırsatı',
    dailyBadge: '🔥 GÜNÜN',
    nightRound: 'Gece Kampanyası',
    nightBadge: '🌙 GECE',
    newCampaignStarted: 'Yeni Kampanya Başladı!',
    dontMiss: 'Kaçırma!',
    nextCampaign: 'Sonraki:',
    hours: 'SAAT',
    minutes: 'DAKİKA',
    seconds: 'SANİYE',
    // SaleProductCard
    discount: 'İNDİRİM',
    reviews: 'değerlendirme',
    stockStatus: 'Stok Durumu',
    stockLeft: 'adet kaldı!',
  },

  // Combo Page
  combo: {
    title: 'Kombin Paketler',
    subtitle: 'Özenle hazırlanmış kombinlerle zamandan ve paradan tasarruf edin. Her pakette uyumlu ürünler bir arada!',
    benefit1Title: 'Uygun Fiyat',
    benefit1Desc: 'Ürünleri ayrı ayrı almaya göre %20-30 daha ucuz',
    benefit2Title: 'Zaman Tasarrufu',
    benefit2Desc: 'Hazır kombinlerle hızlı alışveriş deneyimi',
    benefit3Title: 'Uyumlu Ürünler',
    benefit3Desc: 'Stilistler tarafından özenle seçilmiş kombinler',
    comboBadge: 'Kombin Paketi',
    discountBadge: 'İndirim',
    packageContains: 'Pakette:',
    savings: 'tasarruf!',
    filterAll: 'Tümü',
    filterWomen: 'Kadın',
    filterMen: 'Erkek',
    giftProduct: 'Hediyeli Ürün',
  },

  // Blog Page
  blog: {
    title: 'Blog & İçerikler',
    subtitle: 'FentyBarefoot Blog',
    heroSubtitle: 'Ayak sağlığı, barefoot felsefesi, sürdürülebilir moda ve daha fazlası hakkında bilgilendirici içerikler',
    all: 'Tümü',
    healthLife: 'Sağlık & Yaşam',
    fashionTrend: 'Moda & Trend',
    careCleaning: 'Bakım & Temizlik',
    sustainability: 'Sürdürülebilirlik',
    productKnowledge: 'Ürün Bilgisi',
    readMore: 'Devamını Oku',
    newsletterTitle: 'Blog Güncellemelerini Kaçırmayın',
    newsletterDesc: 'Yeni içeriklerimizden haberdar olmak için e-posta listemize katılın',
    emailPlaceholder: 'E-posta adresiniz',
    subscribe: 'Abone Ol',
    post1Title: 'Barefoot & Organiklik — Topraklama Ayakkabının Faydaları',
    post1Excerpt: 'Topraklama ayakkabıları, ayakkabılarınızın doğal yapısına uygun tasarımıyla sağlığınıza katkı sağlar. Barefoot felsefesi ve organik yaşamın buluşma noktası...',
    post1Category: 'Sağlık & Yaşam',
    post1Date: '15 Haziran 2024',
    post1ReadTime: '8 dk okuma',
    post2Title: 'Yaz Aylarında Ayakkabı Bakımı İpuçları',
    post2Excerpt: 'Sıcak havalarda ayakkabılarınızı nasıl korumalı ve temiz tutmalısınız? Uzun ömürlü kullanım için pratik öneriler...',
    post2Category: 'Bakım & Temizlik',
    post2Date: '10 Haziran 2024',
    post2ReadTime: '5 dk okuma',
    post3Title: 'Ayak Sağlığı için Doğru Ayakkabı Seçimi',
    post3Excerpt: 'Ayak sağlığınızı korumak için ayakkabı seçerken nelere dikkat etmelisiniz? Uzman tavsiyeleri ve öneriler...',
    post3Category: 'Sağlık & Yaşam',
    post3Date: '5 Haziran 2024',
    post3ReadTime: '6 dk okuma',
    post4Title: 'Barefoot Ayakkabı Nedir? Neden Tercih Edilmeli?',
    post4Excerpt: 'Barefoot ayakkabılar geleneksel ayakkabılardan nasıl farklıdır? Ayak sağlığına etkileri ve kullanım alanları...',
    post4Category: 'Ürün Bilgisi',
    post4Date: '1 Haziran 2024',
    post4ReadTime: '7 dk okuma',
    post5Title: '2024 Yaz Sezonu Ayakkabı Trendleri',
    post5Excerpt: 'Bu yaz hangi ayakkabı modelleri öne çıkıyor? Renk paletleri, tasarım detayları ve stil önerileri...',
    post5Category: 'Moda & Trend',
    post5Date: '28 Mayıs 2024',
    post5ReadTime: '5 dk okuma',
    post6Title: 'Organik Malzemelerle Üretilen Ayakkabılar',
    post6Excerpt: 'Sürdürülebilir moda ve çevre dostu üretim süreçleri. Organik malzemelerin avantajları ve geleceği...',
    post6Category: 'Sürdürülebilirlik',
    post6Date: '22 Mayıs 2024',
    post6ReadTime: '6 dk okuma',
    post7Title: 'Sıfır Drop Ayakkabılar: Duruşunuzu Değiştiren Devrim',
    post7Excerpt: 'Topuk ile burun arası sıfır fark anlamına gelen "zero drop" tasarım, doğal duruşu destekleyerek bel, diz ve ayak ağrılarını azaltıyor. Peki bu fark gerçekten bu kadar önemli mi?',
    post7Category: 'Ürün Bilgisi',
    post7Date: '12 Mart 2025',
    post7ReadTime: '6 dk okuma',
    post8Title: 'Geniş Burun Kutulu Ayakkabılar ve Ayak Sağlığına Etkileri',
    post8Excerpt: 'Dar burunlu ayakkabılar onlarca yıldır ayak bozukluklarının başlıca nedeni. Geniş burun kutusu (wide toe box) tasarımı, parmakların doğal yayılmasını sağlayarak bu sorunu kökten çözüyor...',
    post8Category: 'Sağlık & Yaşam',
    post8Date: '5 Şubat 2025',
    post8ReadTime: '7 dk okuma',
    post9Title: 'Barefoot Yürüyüş Botları ile Doğada Özgürlük',
    post9Excerpt: 'Dağ patikalarında, ormanlarda ve doğal arazilerde barefoot botlarla yürümek bambaşka bir deneyim. Zemin hissi, hafiflik ve sağlıklı biyomekaniik bir arada mümkün mü?',
    post9Category: 'Ürün Bilgisi',
    post9Date: '18 Ocak 2026',
    post9ReadTime: '8 dk okuma',
    post10Title: 'Topraklama Botları: Her Adımda Toprağın Enerjisi',
    post10Excerpt: 'İletken bakır detaylı topraklama botları, yürüyüşlerinize yeni bir boyut katıyor. Sonbahar ve kış aylarında bile topraklama etkisini kaybetmeden özgürce adım atabilirsiniz...',
    post10Category: 'Sağlık & Yaşam',
    post10Date: '3 Ekim 2025',
    post10ReadTime: '7 dk okuma',
    post11Title: '2026 Sürdürülebilir Ayakkabı Trendi: Geleceğin Malzemeleri',
    post11Excerpt: 'Kaktüs derisi, mantar misyeli, balık derisi ve biyobozunur taban... 2026 sürdürülebilir ayakkabı trendleri sadece çevreye dost değil, aynı zamanda barefoot felsefesiyle tam örtüşüyor...',
    post11Category: 'Sürdürülebilirlik',
    post11Date: '7 Nisan 2026',
    post11ReadTime: '6 dk okuma',
    post12Title: 'Topraklama ve Uyku Kalitesi: Bilim Ne Diyor?',
    post12Excerpt: 'Uykusuzluk çağımızın en yaygın sağlık sorunlarından biri. Topraklama bilimi uyku kalitesini nasıl artırıyor? Kortizol ritmi, melatonin ve derin uyku döngüleri üzerine araştırmalar...',
    post12Category: 'Sağlık & Yaşam',
    post12Date: '20 Ocak 2026',
    post12ReadTime: '7 dk okuma',
    post13Title: 'Stres ve Anksiyete Üzerinde Topraklamanın Etkisi',
    post13Excerpt: 'Modern yaşamın stres ve anksiyeteye doğal çözüm: topraklama. Earthing ayakkabıları ile günlük hayatta kortizol dengeleme ve ruh sağlığını destekleme...',
    post13Category: 'Sağlık & Yaşam',
    post13Date: '14 Mart 2026',
    post13ReadTime: '6 dk okuma',
    post14Title: 'Yalınayak Yürüyüşün Tarihi: Modern Dünya ile Karşılaştırma',
    post14Excerpt: '200.000 yıllık yalınayak evrimden bugünün kalın tabanlı ayakkabılarına... İnsan vücudu bu değişimi nasıl yaşadı? Tarihi perspektiften barefoot ve modern ayakkabı karşılaştırması...',
    post14Category: 'Sağlık & Yaşam',
    post14Date: '8 Şubat 2026',
    post14ReadTime: '8 dk okuma',
    post15Title: 'Topraklama Bilimi: Araştırmalar ve Kanıtlar',
    post15Excerpt: 'Topraklamanın iltihaplanmayı azaltıp, uyku kalitesini artırdığı ve kronik hastalıklara karşı koruyucu olduğunu bilimsel olarak kanıtlandı mı? Araştırmalar, güvenlik ve süre rehberi...',
    post15Category: 'Sağlık & Yaşam',
    post15Date: '1 Nisan 2026',
    post15ReadTime: '9 dk okuma',
    post16Title: 'Migren ve Baş Ağrısında Grounding Tedavisi',
    post16Excerpt: 'Migrenin nöroinflamatuar boyutu ve topraklamanın CGRP, iltihaplanma ve stres mekanizmaları üzerindeki etkileri. Baş ağrısı için doğal tamamlayıcı yaklaşım olarak grounding...',
    post16Category: 'Sağlık & Yaşam',
    post16Date: '22 Mayıs 2026',
    post16ReadTime: '7 dk okuma',
    post17Title: 'Topraklama ve Uyku Kalitesi: Bilim Ne Diyor?',
    post17Excerpt: 'Beton ve asfalt üzerinde yaşarken de topraklama mümkün mü? Şehirde iletken yüzeyler, park rutinleri ve FentyBarefoot\'un iletken modelleriyle modern dünyada grounding teknikleri...',
    post17Category: 'Sağlık & Yaşam',
    post17Date: '10 Haziran 2026',
    post17ReadTime: '6 dk okuma',
    post18Title: 'Doğal Yaşam İçin Sürdürülebilir Moda',
    post18Excerpt: 'Organik pamuk, keten ve geri dönüştürülebilir malzemelerden üretilen kıyafetlerin önemi ve bilinçli tüketimin faydaları.',
    post18Category: 'Sürdürülebilirlik',
    post18Date: '15 Mart 2026',
    post18ReadTime: '6 dk okuma',
    post19Title: 'Karbon Ayak İzini Azaltmanın Yolları',
    post19Excerpt: 'Günlük hayatta karbon salınımını azaltma yöntemleri, enerji tasarrufu ve bilinçli tüketim alışkanlıkları.',
    post19Category: 'Sürdürülebilirlik',
    post19Date: '20 Mart 2026',
    post19ReadTime: '5 dk okuma',
    post20Title: 'Savaş Mağduru Kadın ve Çocuklara Destek',
    post20Excerpt: 'Her alışverişiniz bir etki yaratır. Gelirin belirli kısmının bağışlanmasıyla toplumsal dayanışma güçlenir.',
    post20Category: 'Sosyal Sorumluluk',
    post20Date: '25 Mart 2026',
    post20ReadTime: '5 dk okuma',
    post21Title: 'Herkese Bir Fidan: Yeşil Gelecek',
    post21Excerpt: 'Her alışverişte fidan dikimi ile doğaya katkı sağlama ve ağaçlandırma projelerinin önemi.',
    post21Category: 'Çevre',
    post21Date: '1 Nisan 2026',
    post21ReadTime: '4 dk okuma',
    post22Title: 'El Yapımı Deri Ürünlerin Hikayesi',
    post22Excerpt: 'Geleneksel üretim teknikleri, el işçiliğinin değeri ve doğal kaliteli malzeme kullanımının önemi.',
    post22Category: 'Ürün Bilgisi',
    post22Date: '5 Nisan 2026',
    post22ReadTime: '7 dk okuma',
    post23Title: 'Organik Kumaşların Sağlığa Faydaları',
    post23Excerpt: 'Kimyasal içermeyen organik kumaşlar cilt dostu yapılarıyla alerji riskini azaltır ve konfor sağlar.',
    post23Category: 'Sağlık & Yaşam',
    post23Date: '10 Nisan 2026',
    post23ReadTime: '6 dk okuma',
    post24Title: 'Karbon Nötr Üretim: FentyBarefoot\'un Çevre Taahhüdü',
    post24Excerpt: 'Karbon nötr üretim süreçleri, yenilenebilir enerji kullanımı ve ölçülebilir çevresel etki.',
    post24Category: 'Sürdürülebilirlik',
    post24Date: '12 Nisan 2026',
    post24ReadTime: '5 dk okuma',
    post25Title: 'Yeşil Gelecek: 50.000+ Fidan Dikildi',
    post25Excerpt: '50.000\'den fazla fidan dikildi. Toplumsal çevre bilinci ve doğa dostu marka vizyonumuz.',
    post25Category: 'Çevre',
    post25Date: '18 Nisan 2026',
    post25ReadTime: '4 dk okuma',
    sustainabilityLabel: 'Sürdürülebilirlik',
    socialLabel: 'Sosyal Sorumluluk',
    environmentLabel: 'Çevre',
    sustainabilitySection: 'Sürdürülebilirlik & Doğal Yaşam',
    newLabel: 'Yeni',
    allPostsLabel: 'Tüm Yazılar',
    statFidan: 'Fidan Dikildi',
    statCarbon: 'Karbon Azaltıldı',
    statPeople: 'Kişiye Ulaşıldı',
    statWaste: 'Atık Geri Dönüştürüldü',
    impactTitle: 'Yeşil Gelecek: 50.000+ Fidan Dikildi',
    impactDesc: 'Her alışverişinizde doğaya bir fidan. Bugüne kadar müşterilerimizle birlikte 50.000\'den fazla fidan diktik.',
  },

  // Filter Sidebar
  filter: {
    filters: 'Filtreler',
    clear: 'Temizle',
    sorting: 'Sıralama',
    popular: 'En Popüler',
    newest: 'En Yeni',
    priceAsc: 'Fiyat: Düşükten Yükseğe',
    priceDesc: 'Fiyat: Yüksekten Düşüğe',
    discount: 'En Yüksek İndirim',
    topRated: 'En Yüksek Puan',
    priceRange: 'Fiyat Aralığı',
    size: 'Beden',
    color: 'Renk',
    black: 'Siyah',
    white: 'Beyaz',
    camel: 'Camel',
    terracotta: 'Terracotta',
    beige: 'Bej',
    green: 'Yeşil',
    cream: 'Krem',
    brown: 'Kahve',
    navy: 'Lacivert',
    olive: 'Zeytin Yeşili',
    freeShipping: 'Ücretsiz Kargo',
    rating: 'Değerlendirme',
    ratingAll: 'Tüm Puanlar',
    rating45plus: '4.5+ Yıldız',
    rating4plus: '4+ Yıldız',
    rating3plus: '3+ Yıldız',
    tags: 'Etiketler',
    tagBestSeller: 'Çok Satan',
    tagNewSeason: 'Yeni Sezon',
    tagOrganic: 'Organik',
    tagVegan: 'Vegan',
    tagPremium: 'Premium',
    tagSpecialPrice: 'Özel Fiyat',
  },

  // Reviews Section
  reviews: {
    title: 'Müşteri Yorumları',
    reviewsCount: 'değerlendirme',
    writeReview: 'Yorum Yaz',
    verified: 'Doğrulanmış Alışveriş',
    size: 'Beden',
    helpful: 'Bu yorum faydalı mıydı?',
    yourRating: 'Puanınız',
    veryBad: 'Çok Kötü',
    bad: 'Kötü',
    average: 'Orta',
    good: 'İyi',
    excellent: 'Mükemmel',
    yourName: 'Adınız',
    namePlaceholder: 'Adınız Soyadınız',
    purchasedSize: 'Satın Aldığınız Beden',
    selectSize: 'Beden seçin (isteğe bağlı)',
    reviewTitle: 'Yorum Başlığı',
    titlePlaceholder: 'Yorumunuzu özetleyin',
    yourReview: 'Yorumunuz',
    reviewPlaceholder: 'Ürün hakkındaki deneyiminizi paylaşın...',
    addPhotos: 'Fotoğraf Ekle',
    maxPhotos: '(En fazla 5 fotoğraf)',
    photosSelected: 'fotoğraf seçildi. Kaldırmak için üzerine gelin.',
    add: 'Ekle',
    cancel: 'İptal',
    submit: 'Yorumu Gönder',
    submitted: 'Yorumunuz Alındı!',
    submittedMessage: 'İncelendikten sonra yayınlanacak. Teşekkürler!',
    customerFavorite: 'Müşteri Favorisi',
    filterAll: 'Tümü',
    stars: 'Yıldız',
    sortNewest: 'En Yeni',
    sortPopular: 'En Popüler',
    sortLiked: 'En Beğenilen',
    featuredVideos: '⭐ Öne Çıkan Videolar',
    allVideos: 'Tüm Videolar',
    videosFound: '{{count}} video bulundu',
    noVideosFound: 'Video bulunamadı',
    noVideosDesc: 'Arama kriterlerinize uygun video bulunamadı. Lütfen farklı bir arama yapın.',
    newsletterTitle: 'Yeni Videolardan Haberdar Olun',
    newsletterDesc: 'E-posta adresinizi girerek yeni video yüklemelerinden haberdar olabilirsiniz.',
    newsletterPlaceholder: 'E-posta adresiniz',
    newsletterBtn: 'Abone Ol',
  },

  sustainability: {
    heroLabel: 'Organic Fashion · Sürdürülebilir Moda',
    heroTitle: 'Doğa ile Uyum İçinde Moda',
    heroSubtitle: 'Organik pamuk, geri dönüştürülmüş malzemeler ve etik üretim ile geleceğe değer katıyoruz',
    heroExplore: 'Koleksiyonu Keşfet',
    heroCerts: 'Sertifikasyonlarımız',
    heroScroll: 'Aşağı Kaydır',
    statWater: 'Su Tasarrufu',
    statPackaging: 'Geri Dönüşümlü Ambalaj',
    statChemical: 'Kimyasal Azaltma',
    statHandmade: 'El Yapımı Ürün',
    statYears: 'Yıllık Deneyim',
    missionLabel: 'Misyon & Vizyon',
    missionTitle: 'Neden FentyBarefoot?',
    missionText: 'Amacımız insanlara sadece güzel ürünler satmak değil; daha sağlıklı, daha özgür ve doğayla daha uyumlu bir yaşam sunmak.',
    visionLabel: 'Vizyonumuz',
    visionText: '2030 yılına kadar %100 karbon nötr üretim hedefimize ulaşmak ve barefoot felsefesini dünya genelinde yaygınlaştırmak.',
    missionLabel2: 'Misyonumuz',
    missionDesc: 'Ayak sağlığını ön planda tutarak tasarlanmış, doğal malzemelerden üretilmiş ve sürdürülebilir bir geleceğ için çalışan moda markası olmak.',
    valuesLabel: 'Değerlerimiz',
    valuesTitle: 'Bizi Biz Yapan 4 Temel Değer',
    value1Title: 'Doğallık',
    value1Text: 'Tüm ürünlerimizde organik ve doğal malzemeler kullanıyoruz.',
    value2Title: 'Sürdürülebilirlik',
    value2Text: 'Çevre dostu üretim süreçleri ve ambalajlama.',
    value3Title: 'Şeffaflık',
    value3Text: 'Üretim sürecimizi, malzemelerimizi ve fiyatlandırmamızı açık tutuyoruz.',
    value4Title: 'Kalite',
    value4Text: 'Her ürün, uzun ömürlü kullanım için özenle üretiliyor.',
    numbersLabel: 'Rakamlarımız',
    numbersTitle: 'Güvenin Kanıtı',
    stat1Value: '200.000+',
    stat1Label: 'Mutlu Müşteri',
    stat2Value: '50+',
    stat2Label: 'Ülke',
    stat3Value: '500+',
    stat3Label: 'El Yapımı Ürün',
    stat4Value: '6+',
    stat4Label: 'Yıllık Deneyim',
    teamLabel: 'Ekibimiz',
    teamTitle: 'Tutkuyla Çalışan Bir Ekip',
    teamSubtitle: 'Tasarımdan üretim, lojistikten müşteri hizmetlerine her alanda uzman kadromuz.',
    certLabel: 'Sertifikasyon',
    certTitle: 'Güvenilirliğimiz Belgelenmiş',
    ctaLabel: 'Birlikte Daha İyi Bir Gelecek',
    ctaTitle: 'Sürdürülebilir Modaya Katılın',
    ctaText: 'FentyBarefoot ailesiyle tanışın ve sürdürülebilir modanın bir parçası olun.',
    ctaExplore: 'Koleksiyonu Keşfet',
    ctaBlog: 'Blog Yazılarımız',
    footerDesc: 'Doğa ile uyum içinde, sürdürülebilir ve etik moda üretiyoruz.',
    footerMaterials: 'Malzemeler',
    footerCerts: 'Sertifikasyonlar',
    footerCollections: 'Koleksiyonlar',
    audioStarted: 'Kadın sesi ile başladı!',
    audioPlaying: 'OYNATILIYOR',
    audioLanguages: 'Mevcut Diller',
  },

  liveChat: {
    title: 'FentyBarefoot Destek',
    online: 'Çevrimiçi · Hızlı Yanıt',
    hello: 'Merhaba!',
    introDesc: 'Size yardımcı olmaktan memnuniyet duyarız. Başlamak için adınızı girin.',
    namePlaceholder: 'Adınız (isteğe bağlı)',
    startChat: 'Sohbete Başla',
    continueAsGuest: 'Misafir olarak devam et',
    welcomeMsg: 'Size nasıl yardımcı olabiliriz? 😊',
    supportTeam: 'Destek Ekibi',
    messagePlaceholder: 'Mesajınızı yazın...',
    secureNote: 'Güvenli bağlantı · Gizliliğiniz korunuyor',
    voiceCall: 'Sesli Görüşme',
    typing: 'Yazıyor...',
    // Call modal
    callTitle: 'Destek Hattı',
    callMinimize: 'Küçült',
    callClose: 'Kapat',
    callConnecting: 'Bağlanıyor...',
    callConnected: 'Bağlantı Kuruldu',
    callBusy: 'Şu an Meşgul',
    callEnded: 'Arama Sona Erdi',
    callWaiting: 'Operatör bekleniyor...',
    callBusyNote: 'Lütfen daha sonra tekrar arayın',
    callLive: 'Canlı bağlantı',
    callHangupNote: 'Aramayı sonlandırmak için kırmızı butona basın',
    // Minimized bar
    callMinBar: 'Destek Hattı',
    callExpand: 'Genişlet',
    // Admin-initiated call (incoming on customer side)
    incomingCallTitle: 'Gelen Sesli Arama',
    incomingCallLine: 'FentyBarefoot Destek Hattı',
    incomingCallMsg: 'Müşteri temsilciniz sizi arıyor. Yanıtlamak ister misiniz?',
    accept: 'Kabul Et',
    reject: 'Reddet',
    // Active call bar
    activeCallTitle: 'Görüşme Aktif',
    activeCallSub: 'FentyBarefoot Destek',
    // Announcements (speech synthesis)
    welcomeAnnouncement: "FentyBarefoot'a hoş geldiniz. Lütfen bekleyin, operatörümüz kısa süre içinde sizinle ilgilenecek.",
    busyAnnouncement: 'Şu anda müşteri temsilcimiz meşgul. Lütfen daha sonra tekrar arayın.',
  },

  // Newsletter Popup
  newsletter: {
    specialOffers: 'Özel Teklifler',
    title: 'Haber Bültenine Katıl',
    description: 'İlk siparişinde',
    discount: '%10 indirim',
    descriptionEnd: 'kazan! Yeni koleksiyonlar ve kampanyalardan ilk sen haberdar ol.',
    emailPlaceholder: 'E-posta adresiniz',
    subscribe: 'Abone Ol & %10 Kazan',
    sending: 'Gönderiliyor...',
    unsubscribe: 'İstediğin zaman abonelikten çıkabilirsin.',
    thanks: 'Teşekkürler! 🎉',
    codeSent: '%10 indirim kodun e-postana gönderildi.',
    startShopping: 'Alışverişe Başla',
    neverShow: 'Bir daha gösterme',
  },

  // Wholesale Popup
  wholesale: {
    title: 'Toptan Satış',
    subtitle: 'Bayi & Toptan Alım Portalı',
    dealerLogin: 'Bayi Girişi',
    dealerApply: 'Bayi Başvurusu',
    dealerCode: 'Bayi Kodu / E-posta',
    dealerCodePlaceholder: 'Bayi kodunuz veya e-postanız',
    password: 'Şifre',
    login: 'Giriş Yap',
    notDealer: 'Henüz bayimiz değil misiniz?',
    apply: 'Başvurun',
    fullName: 'Ad Soyad',
    fullNamePlaceholder: 'Adınız ve soyadınız',
    companyName: 'Firma Adı',
    companyPlaceholder: 'Firma adı',
    email: 'E-posta',
    emailPlaceholder: 'firma@email.com',
    phone: 'Telefon',
    phonePlaceholder: '+90 5xx xxx xx xx',
    city: 'Şehir',
    cityPlaceholder: 'İstanbul',
    taxNumber: 'Vergi No',
    taxPlaceholder: 'Vergi numaranız',
    message: 'Mesajınız',
    messagePlaceholder: 'Kendinizi ve işletmenizi kısaca tanıtın...',
    submitApplication: 'Başvuruyu Gönder',
    submitting: 'Gönderiliyor...',
    applicationReceived: 'Başvurunuz Alındı!',
    contactSoon: 'En kısa sürede sizinle iletişime geçeceğiz.',
    close: 'Kapat'
  },

  // Auth pages
  login: {
    title: 'Üye Girişi',
    email: 'E-posta',
    emailPlaceholder: 'ornek@email.com',
    password: 'Şifre',
    passwordPlaceholder: 'Şifrenizi girin',
    rememberMe: 'Beni Hatırla',
    forgotPassword: 'Şifremi Unuttum',
    loginButton: 'Giriş Yap',
    noAccount: 'Hesabın yok mu?',
    signUp: 'Üye Ol',
    orContinueWith: 'veya devam et',
    google: 'Google ile Giriş',
    welcome: 'Tekrar Hoş Geldin!',
    subtitle: 'Alışverişe devam etmek için giriş yap',
    termsNote: 'Giriş yaparak',
    termsLink: 'Kullanım Şartları',
    termsAnd: 've',
    privacyLink: 'Gizlilik Politikası',
    termsEnd: '\'nı kabul etmiş olursunuz.',
  },
  register: {
    title: 'Üye Ol',
    name: 'Ad Soyad',
    namePlaceholder: 'Adınız ve soyadınız',
    email: 'E-posta',
    emailPlaceholder: 'ornek@email.com',
    password: 'Şifre',
    passwordPlaceholder: 'Güçlü bir şifre oluştur',
    confirmPassword: 'Şifre Tekrar',
    confirmPasswordPlaceholder: 'Şifrenizi tekrar girin',
    terms: 'Kullanım şartlarını kabul ediyorum',
    registerButton: 'Üye Ol',
    haveAccount: 'Zaten hesabın var mı?',
    login: 'Giriş Yap',
    discount: 'Yeni üyelere %10 indirim!',
    passwordStrength: {
      weak: 'Zayıf',
      medium: 'Orta',
      strong: 'Güçlü'
    },
    sslNote: 'Bilgileriniz SSL ile güvenli şekilde korunmaktadır',
  },

  // Welcome Speech
  speech: {
    welcomeText: `Merhaba ve FentyBarefoot'a hoş geldiniz.
Yazın enerjisinin, doğanın özgürlüğünün ve gerçek konfortun bir araya geldiği dünyamıza adım attığınız için çok mutluyuz.
FentyBarefoot.com sadece bir marka değil...
Doğal yaşamı, sürdürülebilir üretimi ve her adımın özgürlüğünü benimseyen bir yaşam tarzıdır.
Özel yaz koleksiyonumuzda; barefoot topraklama ayakkabıları, el yapımı sandaletler, rahat terlikler ve toprağın doğal dokunuşunu taşıyan ürünler bulacaksınız.
Barefoot tasarım felsefemiz, ayaklarınızın doğayla yeniden bağlantı kurmasına yardımcı olarak yürürken zeminin enerjisini hissetmenizi sağlar.
Doğal hareket, gerçek konfort ve özgürlük... hepsi FentyBarefoot dünyasında.
Ürünlerimizde kullandığımız malzemeler özenle seçilmektedir.
Doğal, organik ve sürdürülebilir kaynaklardan üretilmektedir.
Koleksiyonumuzda aynı zamanda sezonun tazeliğini yansıtan yüzde yüz pamuklu yaz kıyafetleri de yer almaktadır.
Nefes alan kumaşlar, doğal dokular ve sade ama sanatsal tasarımlar...
Hepsi sıcak yaz günlerinde size konfort ve şıklık sunmak için yaratıldı.
FentyBarefoot olarak, doğal bir yaşam tarzını destekleyen sürdürülebilir modanın öncülerinden biri olmayı hedefliyoruz.
Her tasarımda doğaya saygı, insan refahına özen ve sanatsal estetiğe değer bulacaksınız.
Özel yaz promosyonlarımız ve indirimlerimizle siz de bu doğal deneyimi keşfedebilirsiniz.
Daha özgür adımlar atmak, doğaya daha yakın hissetmek ve yazın enerjisini tarzınıza katmak istiyorsanız doğru yerdesiniz.
Şimdi koleksiyonumuzu keşfetme zamanı.
Bugün fentybarefoot.com'u ziyaret edin.
Doğal, özgür ve sürdürülebilir bir yaz için...
FentyBarefoot.com sizinle.`,
    lang: 'tr-TR',
    tooltipText: 'Kadın sesi ile anlatım başladı!',
    stopTitle: 'Sesi Durdur',
    listenTitle: 'FentyBarefoot\'u Dinle 🎙️',
  },

  // Sustainability Page Speech
  sustainabilitySpeech: {
    lang: 'tr-TR',
    title: 'Sürdürülebilirlik & Topraklama — Sesli Anlatım',
    playLabel: 'Sesli Anlatımı Dinle',
    stopLabel: 'Durdur',
    text: `FentyBarefoot organic moda mağazasına hoşgeldiniz. Sürdürülebilirlik ve Doğal Yaşam Felsefemiz.

Doğayla uyum içinde yaşamak bir tercih değil, bir sorumluluktur. Biz, modern dünyanın hızına kapılmadan; insanın özüne, doğanın ritmine ve bedenin gerçek ihtiyaçlarına geri dönmeyi savunuyoruz. Ürettiğimiz her ürün, bu felsefenin bir yansımasıdır.

Toprakla temasın insan bedeninin en eski ve en güçlü enerji kaynağıdır. Binlerce yıl boyunca insanlar çıplak ayakla yürüdü, doğayla temas halinde yaşadı. Ancak modern yaşam… bu doğal bağı büyük ölçüde kopardı. İşte tam bu noktada, grounding barefoot ayakkabıların ardındaki bilim devreye giriyor. Grounding yani earthing kavramı, ayağınız ile yeryüzü arasında doğrudan bir enerji köprüsü kurmak için tasarlanmıştır. Bu özel tasarımın kalbinde ise bakır bulunur. Bakır, doğanın en iyi iletkenlerinden biridir. Elektriksel yükleri taşıma kapasitesi sayesinde… vücudunuzda biriken statik elektriği toprağa aktarır ve dünyanın doğal negatif elektronlarıyla temas etmenizi sağlar. Bu süreçte ne olur? Vücudunuz… doğal dengesine geri dönmeye başlar. Topraklama etkisiyle; stres ve gerginlik azalabilir, uyku kalitesi artabilir, kas ve eklem rahatlaması sağlanabilir, kan dolaşımı desteklenebilir, enerji seviyesinde gözle görülür artış hissedilebilir. Barefoot yani çıplak ayak tasarımı ise sadece enerjiyle sınırlı değildir. Geniş burun yapısı sayesinde ayak parmaklarınız doğal olarak yayılır. İnce ve esnek taban, zemini hissetmenizi sağlar. Ayağınız… olması gerektiği gibi hareket eder. Çünkü insan ayağı, desteklenmek için değil… doğal olarak çalışmak için yaratılmıştır. Grounding ayakkabıların tabanında bulunan iletken bakır noktalar, her adımınızda toprağa temas ederek bedeniniz ile dünya arasında kesintisiz bir bağlantı kurar. Bu sadece bir ayakkabı değil… bu, doğaya geri dönüşün bir yoludur. Her adımda… toprağın enerjisini hissedin. Dengeyi hissedin. Doğayı hissedin. Grounding barefoot ayakkabılar ile yeniden bağlanın. Topraklama ve çıplak ayakla yürümenin onarıcı şifa gücünü keşfedin. Dünya yüzeyinden gelen sürekli faydalı elektron akışına bağlanarak, bu bağlantı vücudunuzun doğal iyileşme ve yenilenme süreçlerini destekler ve günlük yaşamınızda optimum sağlık ve esenliği teşvik eder.`,
  },

  // Personalization Popup
  personalizationPopup: {
    title: 'Kişiselleştirme & Hediye',
    subtitle: 'Siparişinizi özel yapın',
    tabNote: 'Sipariş Notu',
    tabGift: 'Hediye Paketi',
    noteInfoText: 'Ürüne özel isim, mesaj, renk tercihi veya herhangi bir isteğinizi buraya yazabilirsiniz. Satıcı siparişinizi hazırlarken bu notu dikkate alacaktır.',
    noteLabel: 'Özel Notunuz',
    notePlaceholder: 'Örn: Üzerine \'Seni Seviyorum\' yazılsın, kırmızı kurdeleli paketlensin, mavi renk tercih ediyorum...',
    charCount: 'karakter',
    clearNote: 'Temizle',
    quickTemplates: 'Hızlı Şablonlar',
    templates: ['İsim yazılsın', 'Doğum günü hediyesi', 'Sürpriz paket', 'Özel mesaj ekle', 'Fatura gönderme'],
    giftWrapTitle: 'Hediye Paketi İstiyorum',
    giftWrapSubtitle: 'Özel ambalaj ve kurdele ile paketlensin',
    ribbonColor: 'Kurdele Rengi',
    ribbonColors: {
      red: 'Kırmızı',
      pink: 'Pembe',
      gold: 'Altın',
      white: 'Beyaz',
      navy: 'Lacivert',
      green: 'Yeşil',
    },
    greetingCard: 'Tebrik Kartı Ekle',
    greetingCardSubtitle: 'El yazısıyla özel kart',
    giftMessage: 'Hediye Mesajı',
    giftMessageOptional: '(isteğe bağlı)',
    giftMessagePlaceholder: 'Örn: İyi ki doğdun! Seni çok seviyorum 🎉',
    giftInactiveTitle: 'Hediye paketi seçeneğini aktif edin',
    giftInactiveSubtitle: 'Sevdiklerinize özel bir sürpriz yapın',
    cancel: 'Vazgeç',
    save: 'Kaydet',
  },

  // Checkout Page
  checkout: {
    // Breadcrumb & Title
    breadcrumbHome: 'Ana Sayfa',
    breadcrumbCheckout: 'Ödeme',
    pageTitle: 'Güvenli Ödeme',
    pageSubtitle: 'Tüm bilgileriniz SSL ile korunmaktadır',
    ssl: '256-bit SSL',
    secure3d: '3D Secure',
    pciDss: 'PCI DSS',

    // Customer Section
    customerTitle: 'Müşteri Bilgileri',
    guestContinue: 'Misafir Olarak Devam',
    memberLogin: 'Üye Girişi',
    guestInfo: 'Misafir olarak sipariş verebilirsiniz. Üye olursanız siparişlerinizi takip edebilir ve özel indirimlerden yararlanabilirsiniz.',
    register: 'Üye Ol',
    firstName: 'Ad',
    firstNamePlaceholder: 'Adınız',
    lastName: 'Soyad',
    lastNamePlaceholder: 'Soyadınız',
    email: 'E-posta',
    emailPlaceholder: 'ornek@email.com',
    phone: 'Telefon',
    phonePlaceholder: '+90 5XX XXX XX XX',
    password: 'Şifre',
    passwordPlaceholder: '••••••••',
    loginButton: 'Giriş Yap',
    noAccount: 'Hesabın yok mu?',
    required: '*',

    // Address Section
    addressTitle: 'Teslimat Adresi',
    address: 'Adres',
    addressPlaceholder: 'Sokak, mahalle, bina no, daire no...',
    city: 'Şehir',
    cityPlaceholder: 'İstanbul',
    postalCode: 'Posta Kodu',
    postalCodePlaceholder: '34000',
    country: 'Ülke',
    orderNote: 'Sipariş Notu',
    orderNoteOptional: '(İsteğe bağlı)',
    orderNotePlaceholder: 'Siparişinizle ilgili özel bir notunuz varsa buraya yazabilirsiniz...',
    saveAddressLabel: 'Bu adresi bir sonraki sipariş için kaydet',
    savedAddressTitle: 'Kayıtlı Adresiniz',
    useSavedAddress: 'Kayıtlı Adresi Kullan',

    // Shipping Section
    shippingTitle: 'Kargo Seçenekleri',
    freeShipping: 'Ücretsiz Kargo',
    freeShippingDays: '5-7 iş günü',
    freeShippingBadge: 'Ücretsiz',
    freeShippingNote: 'Tüm siparişlerde geçerli.',

    // Payment Section
    paymentTitle: 'Ödeme Yöntemi',
    creditCard: 'Kredi / Banka Kartı',
    creditCardDesc: 'Visa, Mastercard, Amex',
    paypalDesc: 'PayPal hesabınızla ödeyin',
    iyzicoDesc: 'Güvenli Türk ödeme altyapısı',
    transfer: 'Havale / EFT',
    transferDesc: 'Banka havalesi ile ödeme',
    cardInfo: 'Kart Bilgileri',
    cardName: 'Kart Üzerindeki İsim',
    cardNamePlaceholder: 'AD SOYAD',
    cardNumber: 'Kart Numarası',
    cardNumberPlaceholder: '0000 0000 0000 0000',
    cardExpiry: 'Son Kullanma Tarihi',
    cardExpiryPlaceholder: 'AA/YY',
    cardCvv: 'CVV',
    cardCvvPlaceholder: '•••',
    cardSecureNote: 'Kart bilgileriniz 256-bit SSL ile şifrelenerek güvenle iletilmektedir.',
    paypalTitle: 'PayPal ile Güvenli Ödeme',
    paypalNote: 'Siparişi onayladığınızda PayPal ödeme sayfasına yönlendirileceksiniz.',
    paypalProtection: 'PayPal Alıcı Koruması aktif',
    scrollUp: 'Yukarı Kaydır',
    menu: 'MENÜ',
    up: 'YUKARI',
    dayMode: 'Gündüz',
    nightMode: 'Gece',
    liveSupport: 'Canlı Destek',
    liveSupportStatus: 'Şu an aktif',
  },

  // Order Summary
  orderSummary: {
    title: 'Sipariş Özeti',
    products: 'ürün',
    emptyCartMsg: 'Sepetiniz boş',
    discountCode: 'İndirim Kodu',
    couponPlaceholder: 'KODU GİRİN',
    couponApplied: '%10 indirim uygulandı!',
    couponAutoApplied: 'Kupon kodu otomatik uygulandı!',
    couponAutoAppliedDesc: 'kodu indiriminize yansıtıldı.',
    couponHowToTitle: 'Kupon Nasıl Kullanılır?',
    couponHowToDesc: 'Ödeme sayfasında "İndirim Kodu" alanına kupon kodunuzu girin ve "Uygula" butonuna tıklayın. İndirim sepet toplamına otomatik uygulanır.',
    couponMinOrder: 'Bu kupon için minimum sipariş tutarı {{amount}}',
    couponMinOrderDesc: 'Bu kupon kodu kullanmak için siparişiniz minimum {{amount}} olmalıdır.',
    errCouponMinOrder: 'Bu kupon için minimum sipariş tutarı {{amount}}',
    couponApplicable: 'Uygulanabilir',
    applyCouponToCart: 'Sepete Uygula',
    cartApplicableCoupons: 'Sepetinize Uygulanabilir Kuponlar',
    cartApplicableDesc: 'Güncel sepet tutarınız ({{total}}) için kullanılabilir kuponlar',
    subtotal: 'Ara Toplam',
    shipping: 'Kargo',
    free: 'Ücretsiz',
    discount: 'İndirim',
    total: 'Toplam',
    vatIncluded: 'KDV dahil',
    sslSecure: 'SSL Güvenli',
    easyReturn: 'Kolay İade',
    qty: 'Adet',

    // Success Page
    successTitle: 'Siparişiniz Alındı! 🎉',
    successSubtitle: 'Teşekkürler! Siparişiniz başarıyla oluşturuldu ve hazırlanmaya başlandı.',
    orderNumberLabel: 'Sipariş Numaranız',
    orderNumberNote: 'Bu numarayı not alın, sipariş takibinde kullanabilirsiniz.',
    estimatedDelivery: 'Tahmini teslimat',
    businessDays: 'İş Günü',
    paymentLabel: 'Ödeme',
    confirmEmail: 'Onay E-postası',
    confirmEmailSent: 'Gönderildi',
    orderDetails: 'Sipariş Detayları',
    deliveryAddress: 'Teslimat Adresi',
    orderProcess: 'Sipariş Süreci',
    stepReceived: 'Sipariş Alındı',
    stepPreparing: 'Hazırlanıyor',
    stepShipped: 'Kargoya Verildi',
    stepDelivered: 'Teslim Edildi',
    backHome: 'Ana Sayfaya Dön',
    continueShopping: 'Alışverişe Devam',
    contactUs: 'müşteri hizmetlerimizle',
    contactNote: 'Sorularınız için',
    contactEnd: 'iletişime geçebilirsiniz.',
    paymentCreditCard: 'Kredi Kartı',
    paymentTransfer: 'Havale/EFT',

    // Footer
    footerTagline: 'Güvenli alışveriş garantisi',
    footerContact: 'İletişim',
    footerShipping: 'Kargo Bilgisi',
    footerReturns: 'İade Politikası',
    footerSsl: '256-bit SSL Güvenli Ödeme',
  },

  // Cart Drawer
  cart: {
    title: 'Sepetim',
    items: 'ürün',
    empty: 'Sepetiniz boş',
    emptyDesc: 'Ürünleri keşfetmek için alışverişe başlayın',
    startShopping: 'Alışverişe Başla',
    color: 'Renk',
    size: 'Beden',
    shoeSize: 'No',
    gift: 'Hediye',
    note: 'Not',
    subtotal: 'Ara Toplam',
    shipping: 'Kargo',
    free: 'Ücretsiz',
    total: 'Toplam',
    checkout: 'Ödemeye Geç',
    continueShopping: 'Alışverişe Devam Et',
    customsTax: 'Gümrük vergisi: %0 —',
    noExtraFee: 'Ekstra ödeme yok, tüm vergiler dahil!',
    estimatedDelivery: 'Tahmini teslimat: 23 Mart (6 iş günü)',
    returnPolicy: 'İade & Değişim Politikası',
    returnPolicyTitle: 'İade & Değişim Politikası',
    returnPolicyClose: 'Kapat',
    returnPolicy30Days: '30 Gün İade Hakkı',
    returnPolicy30DaysDesc: 'Teslim aldığınız tarihten itibaren 30 gün içinde iade edebilirsiniz.',
    returnPolicyFreeReturn: 'Ücretsiz İade Kargosu',
    returnPolicyFreeReturnDesc: 'Tüm iade ve değişimler için kargo ücretini biz karşılıyoruz.',
    returnPolicyRefundTime: '5-7 İş Günü Para İadesi',
    returnPolicyRefundTimeDesc: 'Ürün elimiz ulaştıktan sonra 5-7 iş günü içinde ödemeniz iade edilir.',
    returnPolicyExchange: 'Kolay Değişim',
    returnPolicyExchangeDesc: 'Beden veya renk değişikliği için ücretsiz değişim hakkınız mevcuttur.',
    returnPolicyNote: 'İade ve değişimler orijinal ambalajında, kullanılmamış ve etiketleri sökülmemiş ürünler için geçerlidir.',
    sole: 'Sole',
    usSize: 'Numara',
  },

  popularProducts: {
    title: '🏆 Popüler Ürünler',
    subtitle: 'En çok tercih edilen ürünlerimizi keşfedin',
    tabReviews: '🏆 En Çok Yorum Alan',
    tabFavorites: '❤️ En Çok Favori',
    tabSales: '🔥 En Çok Satan',
    viewProduct: 'Ürünü Gör',
  },

  videos: {
    channelLabel: 'Video Kanalı',
    live: 'CANLI',
    watchNow: 'Hemen İzle',
    subscribe: 'Abone Ol',
    videos: 'Video',
    views: 'İzlenme',
    likes: 'Beğeni',
    subscribers: 'Abone',
    awards: 'Ödül',
    searchPlaceholder: 'Video ara...',
    sortNewest: 'En Yeni',
    sortPopular: 'En Popüler',
    sortLiked: 'En Beğenilen',
    featuredVideos: '⭐ Öne Çıkan Videolar',
    allVideos: 'Tüm Videolar',
    videosFound: '{{count}} video bulundu',
    noVideosFound: 'Video bulunamadı',
    noVideosDesc: 'Arama kriterlerinize uygun video bulunamadı. Lütfen farklı bir arama yapın.',
    newsletterTitle: 'Yeni Videolardan Haberdar Olun',
    newsletterDesc: 'E-posta adresinizi girerek yeni video yüklemelerinden haberdar olabilirsiniz.',
    newsletterPlaceholder: 'E-posta adresiniz',
    newsletterBtn: 'Abone Ol',
  },

  aboutUs: {
    pageTitle: 'Hakkımızda — FentyBarefoot',
    heroTitle: 'Doğa ile Uyum İçinde Moda',
    heroSubtitle: 'Her adımda özgürlük, her ürünle sürdürülebilirlik',
    storyLabel: 'Hikayemiz',
    storyTitle: 'FentyBarefoot Nasıl Doğdu?',
    storyP1: '2018 yılında İstanbul\'da küçük bir barefoot ayakkabı atöösi olarak başlayan FentyBarefoot, bugün Avrupa\'nın önde gelen sürdürülebilir moda markalarından biri haline geldi.',
    storyP2: 'Kurucumuz Leyla Fenton, organik tarım çiftliklerinde büyürken ayaklarının toprağa değdiği o özgürlük hissini hiç unutmadı. Bu duyguyu herkesle paylaşma hayaliyle barefoot ayakkabı tasarlamaya başladı.',
    storyP3: 'Bugün 50\'den fazla ülkeye ürün gönderiyoruz. Tüm ürünlerimiz elle üretiliyor, organik malzemeler kullanılıyor ve her adımda doğa korunuyor.',
    missionLabel: 'Misyon & Vizyon',
    missionTitle: 'Neden FentyBarefoot?',
    missionText: 'Amacımız insanlara sadece güzel ürünler satmak değil; daha sağlıklı, daha özgür ve doğayla daha uyumlu bir yaşam sunmak.',
    visionLabel: 'Vizyonumuz',
    visionText: '2030 yılına kadar %100 karbon nötr üretim hedefimize ulaşmak ve barefoot felsefesini dünya genelinde yaygınlaştırmak.',
    missionLabel2: 'Misyonumuz',
    missionDesc: 'Ayak sağlığını ön planda tutarak tasarlanmış, doğal malzemelerden üretilmiş ve sürdürülebilir bir geleceğ için çalışan moda markası olmak.',
    valuesLabel: 'Değerlerimiz',
    valuesTitle: 'Bizi Biz Yapan 4 Temel Değer',
    value1Title: 'Doğallık',
    value1Text: 'Tüm ürünlerimizde organik ve doğal malzemeler kullanıyoruz.',
    value2Title: 'Sürdürülebilirlik',
    value2Text: 'Çevre dostu üretim süreçleri ve ambalajlama.',
    value3Title: 'Şeffaflık',
    value3Text: 'Üretim sürecimizi, malzemelerimizi ve fiyatlandırmamızı açık tutuyoruz.',
    value4Title: 'Kalite',
    value4Text: 'Her ürün, uzun ömürlü kullanım için özenle üretiliyor.',
    numbersLabel: 'Rakamlarımız',
    numbersTitle: 'Güvenin Kanıtı',
    stat1Value: '200.000+',
    stat1Label: 'Mutlu Müşteri',
    stat2Value: '50+',
    stat2Label: 'Ülke',
    stat3Value: '500+',
    stat3Label: 'El Yapımı Ürün',
    stat4Value: '6+',
    stat4Label: 'Yıllık Deneyim',
    teamLabel: 'Ekibimiz',
    teamTitle: 'Tutkuyla Çalışan Bir Ekip',
    teamSubtitle: 'Tasarımdan üretim, lojistikten müşteri hizmetlerine her alanda uzman kadromuz.',
    certLabel: 'Sertifikasyon',
    certTitle: 'Güvenilirliğimiz Belgelenmiş',
    ctaTitle: 'Birlikte Daha İyi Bir Gelecek',
    ctaText: 'FentyBarefoot ailesiyle tanışın ve sürdürülebilir modanın bir parçası olun.',
    ctaBtn: 'Koleksiyonu Keşfet',
    breadcrumb: 'Hakkımızda',
    noWarBadge: 'Barış İçin Duruş',
    noWarTitle: 'Savaşa Hayır, Yaşama Evet',
    noWarSubtitle: 'Hiçbir insan ölümünü desteklemiyoruz. Kimyasal silahlara, doğanın dengesini bozan her eyleme ve tüm canlılara zarar veren her şeye karşıyız.',
    noWarP1: 'Gerçek sürdürülebilirlik; insanın insana, insanın doğaya verdiği her türlü zarara karşı durmayı gerektirir. Bu nedenle savaşa, şiddete ve kimyasal silahlara açıkça karşı olduğumuzu ilan ediyoruz.',
    noWarP2: 'Kimyasal silahlar; toprağı, suyu ve havayı kirletir. Atmosferi bozan, dünya dengesini tahrip eden, canlıların yaşam hakkını elinden alan bu araçlara karşı olmak; gezegenimize duyduğumuz saygının ayrılmaz bir parçasıdır.',
    noWarP3: 'FentyBarefoot olarak barışçıl ve yeşil bir dünya için çalışıyor, gelecek nesillere sürdürülebilir ve güvenli bir yaşam ortamı bırakmayı taahhüt ediyoruz.',
    noWarStat1: 'Savaş Karşıtıyız',
    noWarStat2: 'Kimyasal Silahlara Karşıyız',
    noWarStat3: 'Doğayı Koruyoruz',
    noWarStat4: 'Yaşamı Savunuyoruz',
    noWarQuote: 'Barış olmadan sürdürülebilirlik olmaz. İnsanlığa ve doğaya zarar veren her şeye karşı durmak, hem etik hem de ekolojik bir sorumluluktur.',
  },

  termsConditions: {
    pageTitle: 'Kullanım Koşulları — FentyBarefoot',
    title: 'Kullanım Koşulları',
    subtitle: 'Son güncelleme: Ocak 2026',
    intro: 'FentyBarefoot web sitesini kullanarak aşağıdaki kullanım koşullarını kabul etmiş olursunuz. Lütfen dikkatlice okuyunuz.',
    sec1Title: '1. Genel Hükümler',
    sec1Text: 'Bu web sitesi FentyBarefoot tarafından işletilmektedir. Siteye erişim ve kullanım, bu koşulların kabulü anlamına gelir. Koşulları kabul etmiyorsanız siteyi kullanmayınız.',
    sec2Title: '2. Hesap ve Üyelik',
    sec2Text: 'Hesap oluştururken doğru ve eksiksiz bilgi vermelisiniz. Hesabınızın güvenliğinden siz sorumlusunuz. Şüpheli durumlarda derhal bize bildirin.',
    sec3Title: '3. Satın Alma ve Ödeme',
    sec3Text: 'Tüm fiyatlar belirtilen para biriminde KDV dahil olarak sunulmaktadır. Siparişinizin onaylanması, taraflar arasında bir satış sözleşmesi kurulduğu anlamına gelir.',
    sec4Title: '4. Teslimat',
    sec4Text: 'Teslimat süreleri sipariş onayından itibaren belirtilen iş günlerini kapsar. Yanlış adres bilgisi nedeniyle oluşan gecikmelerden şirketimiz sorumlu değildir.',
    sec5Title: '5. İptal ve İade',
    sec5Text: 'Siparişinizi teslim aldıktan sonra 30 gün içinde iade edebilirsiniz. Hazırlanmış siparişler iptal edilemez; iade süreci başlatılabilir.',
    sec6Title: '6. Fikri Mülkiyet',
    sec6Text: 'Web sitesindeki tüm içerikler — metinler, görseller, logolar — FentyBarefoot\'un mülkiyetindedir. İzinsiz kopyalama ve ticari kullanım yasaktır.',
    sec7Title: '7. Sorumluluk Sınırlandırması',
    sec7Text: 'FentyBarefoot, kullanım hatalarından, mücbir sebep durumlarından veya üçüncü taraf hizmet kesintilerinden kaynaklanan zararlardan sorumlu tutulamaz.',
    sec8Title: '8. Uygulanacak Hukuk',
    sec8Text: 'Bu koşullar Türkiye Cumhuriyeti hukukuna tabidir. Uyuşmazlıklarda İstanbul Mahkemeleri yetkilidir.',
    contactTitle: 'İletişim',
    contactText: 'Sorularınız için: hukuk@fentybarefoot.com',
    breadcrumb: 'Kullanım Koşulları',
  },

  privacyPolicy: {
    pageTitle: 'Gizlilik & Çerez Politikası — FentyBarefoot',
    title: 'Gizlilik & Çerez Politikası',
    subtitle: 'Son güncelleme: Ocak 2026',
    intro: 'FentyBarefoot olarak kişisel verilerinizin gizliliğine büyük önem veriyoruz. Bu politika, verilerinizi nasıl topladığımızı, işlediğimizi ve koruduğumuzu açıklar.',
    dataTitle: 'Topladığımız Kişisel Veriler',
    data1: 'Kimlik bilgileri: Ad, soyad',
    data2: 'İletişim bilgileri: E-posta, telefon numarası',
    data3: 'Adres bilgileri: Teslimat ve fatura adresi',
    data4: 'Ödeme bilgileri: Kart son 4 hanesi (tam kart bilgileri saklanmaz)',
    data5: 'Kullanım verileri: Site gezinme istatistikleri (anonim)',
    usageTitle: 'Verilerin Kullanım Amaçları',
    usage1: 'Sipariş işleme ve teslimat',
    usage2: 'Müşteri hizmetleri ve destek',
    usage3: 'Yasal yükümlülüklerin yerine getirilmesi',
    usage4: 'Pazarlama iletişimi (onayınız alınarak)',
    usage5: 'Site güvenliği ve hizmet iyileştirme',
    cookieTitle: 'Çerez (Cookie) Politikası',
    cookieIntro: 'Web sitemizde üç tür çerez kullanılmaktadır:',
    cookie1Title: 'Zorunlu Çerezler',
    cookie1Text: 'Siteyi düzgün çalıştırmak için gereklidir. Devre dışı bırakılamaz.',
    cookie2Title: 'Performans Çerezleri',
    cookie2Text: 'Google Analytics ile site kullanımını analiz eder. Anonim veriler toplanır.',
    cookie3Title: 'Pazarlama Çerezleri',
    cookie3Text: 'Kişiselleştirilmiş reklamlar için kullanılır. Onayınızla aktif edilir.',
    sharingTitle: 'Veri Paylaşımı',
    sharingText: 'Verileriniz; sipariş teslimatı için kargo şirketleri, ödeme güvenliği için ödeme kuruluşları ve yasal zorunluluklar dışında üçüncü taraflarla paylaşılmaz.',
    rightsTitle: 'KVKK Kapsamındaki Haklarınız',
    rights1: 'Kişisel verilerinizin işlenip işlenmediğini öğrenme',
    rights2: 'İşlenen verileriniz hakkında bilgi talep etme',
    rights3: 'Yanlış verilerin düzeltilmesini talep etme',
    rights4: 'Verilerinizin silinmesini talep etme (unutulma hakkı)',
    rights5: 'Veri işlemeye itiraz etme',
    securityTitle: 'Güvenlik Önlemleri',
    securityText: '256-bit SSL şifreleme, güvenli sunucular ve düzenli güvenlik denetimleriyle verilerinizi en üst düzeyde koruyoruz.',
    contactTitle: 'İletişim',
    contactText: 'KVKK başvuruları ve gizlilik sorularınız için: kvkk@fentybarefoot.com',
    breadcrumb: 'Gizlilik & Çerez Politikası',
  },

  returnsExchanges: {
    pageTitle: 'İade ve Değişim — FentyBarefoot',
    title: 'İade ve Değişim',
    subtitle: 'Hızlı, hızlı ve ücretsiz iade garantisi',
    hero1Value: '30 Gün',
    hero1Label: 'İade Süresi',
    hero2Value: 'Ücretsiz',
    hero2Label: 'İade Kargo',
    hero3Value: '7-12 Gün',
    hero3Label: 'Para İadesi',
    hero4Value: 'Sınırsız',
    hero4Label: 'Değişim Hakkı',
    processTitle: 'İade Süreci — 4 Adımda',
    step1Title: 'İade Talebi',
    step1Text: 'Sipariş numaranız ile destek@fentybarefoot.com adresine yazın veya canlı chat kullanın.',
    step2Title: 'Onay Alın',
    step2Text: '24 saat içinde iade onayı ve ücretsiz kargo kodu e-postanıza gönderilir.',
    step3Title: 'Ürünü Gönderin',
    step3Text: 'Ürünü orijinal ambalajında, verilen kargo koduyla göndermeniz yeterli.',
    step4Title: 'Para İadenizi Alın',
    step4Text: 'Ürün elimiz ulaştıktan sonra 5-7 iş günü içinde orijinal ödeme yönteminize iade yapılır.',
    condTitle: 'İade Koşulları',
    cond1: 'Teslimattan itibaren 30 gün içinde iade talebi oluşturulmalıdır',
    cond2: 'Ürün kullanılmamış ve orijinal ambalajında olmalıdır',
    cond3: 'Tüm etiketler sökülmemiş olmalıdır',
    cond4: 'İndirimli ürünler de aynı iade koşullarına tabidir',
    cond5: 'Kişiselleştirilmiş ürünler iade edilemez',
    exchTitle: 'Değişim Politikası',
    exchText: 'Beden veya renk değişikliği için ücretsiz değişim hakkınız mevcuttur. Değişim talebinizi sipariş teslimatinden itibaren 30 gün içinde iletebilirsiniz. Değişim için yeni ürün stokta ise aynı gün kargoya verilir.',
    faqTitle: 'Sıkça Sorulan Sorular',
    faq1Q: 'Para iadesi ne zaman yapılır?',
    faq1A: 'Ürün tarafımıza ulaştıktan 5-7 iş günü içinde orijinal ödeme yönteminize iade yapılır.',
    faq2Q: 'Ulusal siparişler için iade edebilir miyim?',
    faq2A: 'Evet! Uluslararası siparişler için de 30 günlük iade hakkınız mevcuttur. Kargo ücretini biz karşılıyoruz.',
    faq3Q: 'Hasarlı ürün teslim aldım, ne yapmalıyım?',
    faq3A: 'Hasarlı ürünü 48 saat içinde fotoğraflı olarak bildirin. Derhal yeni ürün gönderiyoruz, kalıcı iz bırakmaz',
    faq4Q: 'Kaç kez değişim yapabilirim?',
    faq4A: 'Her sipariş için bir kez ücretsiz değişim hakkınız vardır.',
    contactTitle: 'Sorunuz mu var?',
    contactText: 'Kargo konularında 7/24 destek hattımıza ulaşabilirsiniz.',
    contactBtn: 'Destek Al',
    breadcrumb: 'İade ve Değişim',
  },

  deliveryShipping: {
    pageTitle: 'Teslimat ve Kargo — FentyBarefoot',
    title: 'Teslimat ve Kargo',
    subtitle: 'Hızlı, güvenli ve çoğunlukla ücretsiz',
    hero1Value: 'Ücretsiz',
    hero1Label: 'Standart Kargo',
    hero2Value: '3-5 Gün',
    hero2Label: 'Yurt İçi',
    hero3Value: '7-12 Gün',
    hero3Label: 'Uluslararası',
    hero4Value: '50+',
    hero4Label: 'Teslimat Ülkesi',
    domesticTitle: 'Yurt İçi Teslimat (Türkiye)',
    domesticIntro: 'Türkiye genelinde tüm siparişlerde ücretsiz kargo. Siparişler 1-2 iş günü içinde hazırlanıp kargoya verilir.',
    domestic1Title: 'Standart Kargo',
    domestic1Time: '3-5 iş günü',
    domestic1Price: 'Ücretsiz',
    domestic2Title: 'Ekspres Kargo',
    domestic2Time: '1-2 iş günü',
    domestic2Price: '₺29,90',
    domestic3Title: 'Aynı Gün Teslimat',
    domestic3Time: 'İstanbul içi',
    domestic3Price: '₺49,90 (150 TL üzeri)',
    intlTitle: 'Uluslararası Teslimat',
    intlIntro: 'Dünya genelinde 50\'den fazla ülkeye gönderim yapıyoruz. Uluslararası siparişlerinde gümrük vergileri ülkeye göre değişir.',
    intl1Region: 'Avrupa',
    intl1Time: '7-12 iş günü',
    intl1Price: 'Ücretsiz (150€+) / 12€',
    intl2Region: 'ABD & Kanada',
    intl2Time: '10-15 iş günü',
    intl2Price: 'Ücretsiz (200$+) / 18$',
    intl3Region: 'Orta Doğu',
    intl3Time: '8-14 iş günü',
    intl3Price: '15$',
    intl4Region: 'Diğer Ülkeler',
    intl4Time: '12-20 iş günü',
    intl4Price: 'İletişime geçin',
    trackTitle: 'Kargo Takibi',
    trackText: 'Siparişiniz kargoya verildiğinde e-posta ile takip numaranız gönderilir. Kargo şirketinin web sitesi veya uygulama üzerinden anlık takip yapabilirsiniz.',
    customsTitle: 'Gümrük ve Vergiler',
    customsText: 'Türkiye siparişlerinde gümrük veya ekstra vergi uygulanmaz. Avrupa siparişlerinde KDV fiyata dahildir. Diğer ülkelerde yerel gümrük mevzuatu geçerlidir.',
    faqTitle: 'Sıkça Sorulan Sorular',
    faq1Q: 'Kargom ne zaman teslim edilir?',
    faq1A: 'Siparişiniz kargoya verildikten sonra e-posta ile bildirim numaranız gönderilir. Spam klasörünü kontrol etmeyi unutmayın.',
    faq2Q: 'Kargo ücretsiz mi?',
    faq2A: 'Evet! Türkiye genelinde tüm siparişlerde kargo ücretsizdir. Avrupa\'da 150€, ABD\'de 200$ üzeri siparişlerde de ücretsiz kargo geçerlidir.',
    faq3Q: 'Sipariş onayı ne zaman gelir?',
    faq3A: 'Siparişiniz tamamlandıktan sonra e-posta onayı gönderilir. Spam klasörünü kontrol etmeyi unutmayın.',
    faq4Q: 'Paket adresimi değiştirebilir miyim?',
    faq4A: 'Sipariş kargoya verilmeden önce adres değişikliği yapabilirsiniz. Kargoya verildikten sonra adres değişikliği mümkün olmayabilir.',
    contactTitle: 'Sorunuz mu var?',
    contactText: 'Kargo konularında 7/24 destek hattımıza ulaşabilirsiniz.',
    contactBtn: 'Destek Al',
    breadcrumb: 'Teslimat ve Kargo',
  },
  
  returnPolicyPopup: {
    title: 'İade & Değişim Politikası',
    subtitle: '30 gün içinde kolay, hızlı ve ücretsiz iade',
    close: 'Kapat',
    point1Title: '30 Gün İade Hakkı',
    point1Desc: 'Teslim aldığınız tarihten itibaren 30 gün içinde ücretsiz iade edebilirsiniz.',
    point2Title: 'Ücretsiz İade Kargosu',
    point2Desc: 'Tüm iade ve değişim işlemlerinde kargo ücreti tarafımızca karşılanmaktadır.',
    point3Title: '5-7 Gün Para İadesi',
    point3Desc: 'Ürün elimiz ulaştıktan sonra 5-7 iş günü içinde orijinal ödeme yönteminize iade yapılır.',
    point4Title: 'Kolay Değişim',
    point4Desc: 'Beden veya renk değişikliği için ücretsiz değişim hakınız mevcuttur.',
    point5Title: 'Orijinal Paket Şartı',
    point5Desc: 'Ürün kullanılmamış, etiketi sökülmemiş ve orijinal ambalajında olmalıdır.',
    ctaBtn: 'Detaylı İade Politikası',
    detailsLink: '/returns-exchanges',
  },

  faqPage: {
    title: 'Sıkça Sorulan Sorular',
    subtitle: 'Merak ettiğiniz her şeyin cevabı burada',
    breadcrumb: 'S.S.S.',
    searchPlaceholder: 'Soru ara...',
    allCategories: 'Tümü',
    catOrders: 'Siparişler',
    catShipping: 'Kargo',
    catReturns: 'İade & Değişim',
    catProducts: 'Ürünler',
    catPayments: 'Ödeme',
    noResults: 'Arama sonucu bulunamadı',
    noResultsDesc: 'Farklı bir arama terimi deneyin veya tüm kategorilere göz atın.',
    contactTitle: 'Hâlâ Sorunuz Mu Var Mı?',
    contactText: 'Müşteri hizmetlerimiz 7/24 yardımcı olmaya hazır.',
    contactBtn: 'Canlı Destek',
    questions: [
      { cat: 'orders', q: 'Siparişimi nasıl takip edebilirim?', a: 'Siparişiniz kargoya verildikten sonra e-posta ile bildirim numaranız gönderilir. UPS\'in web sitesi veya uygulaması üzerinden anlık takip yapabilirsiniz.' },
      { cat: 'orders', q: 'Siparişimi iptal edebilir miyim?', a: 'Sipariş henüz hazırlanmaya başlamadıysa iptal edebilirsiniz. Müşteri hizmetlerimizle iletişime geçmeniz yeterlidir. Hazırlanmaya başladı olan siparişler için iade süreci başlatılır.' },
      { cat: 'orders', q: 'Yanlış ürün sipariş ettim, ne yapmalıyım?', a: 'Siparişiniz kargoya verilmeden önce hata bildirirseniz, siparişi güncelleyebiliriz. Teslimat tarihinden itibaren ise ücretsiz iade ve yeniden sipariş imkanı sunuyoruz.' },
      { cat: 'orders', q: 'Sipariş onayı ne zaman gelir?', a: 'Siparişiniz tamamlandıktan sonra e-posta onayı gönderilir. Spam klasörünü kontrol etmeyi unutmayın.' },
      { cat: 'shipping', q: 'Kargo ücreti ne kadar?', a: 'Evet! Türkiye genelinde tüm siparişlerde kargo ücretsizdir. Avrupa\'da 150€, ABD\'de 200$ üzeri siparişlerde de ücretsiz kargo geçerlidir.' },
      { cat: 'shipping', q: 'Teslimat süresi ne kadar?', a: 'UPS ile çalışıyoruz. Türkiye\'de 3-5 iş günü, uluslararası siparişlerde ortalama 6-12 iş günü içinde teslim edilir.' },
      { cat: 'shipping', q: 'Ulusal kargo yapıyor musunuz?', a: 'Evet! 50\'den fazla ülkeye gönderi yapıyoruz. Sipariş sayfasında kargo bölgenizi seçerek tahmini teslimat tarihini göebilirsiniz.' },
      { cat: 'shipping', q: 'Gümrük vergisi ödeyecek miyim?', a: 'Türkiye siparişlerinde gümrük veya ekstra vergi uygulanmaz. Avrupa siparişlerinde KDV fiyata dahildir. Diğer ülkelerde yerel gümrük mevzuatu geçerlidir.' },
      { cat: 'returns', q: 'Ürünü iade etmek istiyorum, ne yapmalıyım?', a: 'Sipariş numaranızla destek@fentybarefoot.com adresine yazın veya canlı destek kullanın. 24 saat içinde onay ve ücretsiz kargo kodu e-postanıza gönderilir.' },
      { cat: 'returns', q: 'Para iadesi ne zaman yapılır?', a: 'Ürün tarafımıza ulaştıktan 5-7 iş günü içinde orijinal ödeme yönteminize iade yapılır.' },
      { cat: 'returns', q: 'Hasarlı ürün teslim aldım, ne yapmalıyım?', a: 'Hasarlı ürünü 48 saat içinde fotoğraflı olarak bildirin. Derhal yeni ürün gönderiyoruz, herhangi bir iade süreci uygulanmaz.' },
      { cat: 'returns', q: 'Beden değişimi yapabilir miyim?', a: 'Evet! Her sipariş için bir kez ücretsiz beden veya renk değişimi yapabilirsiniz. Teslimat tarihinden itibaren 30 gün içinde talep oluşturmanız yeterlidir.' },
      { cat: 'products', q: 'Ürünleriniz organik malzemeden mi üretiliyor?', a: 'Tüm ürünlerimiz GOTS sertifikalı organik pamuk, doğal deri ve geri dönüştürülmüş malzemelerden üretilmektedir. Kimyasal boyar madde kullanılmaz.' },
      { cat: 'products', q: 'Beden tablosu nerede?', a: 'Her ürün sayfasında detaylı beden rehberi bulunur. Sayfada "Beden Rehberi" butonuna tıklayarak interaktif tabloyu görebilirsiniz.' },
      { cat: 'products', q: 'Ürünler su geçirmez mi?', a: 'Barefoot sandalet ve terliklerimiz su dayanımlıdır. Bot modellerimizin bir kısmında su geçirmezlik özelliği mevcuttur. Ürün sayfasında detayları görebilirsiniz.' },
      { cat: 'payments', q: 'Hangi ödeme yöntemlerini kabul ediyorsunuz?', a: 'Visa, Mastercard, American Express kredi/banka kartı, PayPal, havale/EFT ve iyzico ile ödeme kabul edilmektedir.' },
      { cat: 'payments', q: 'Taksit imkanı var mı?', a: 'Evet! Desteklenen bankaların kredi kartları ile 3, 6 ve 9 taksit seçeneği mevcuttur. Taksit seçeneklerini ödeme sayfasında görebilirsiniz.' },
      { cat: 'payments', q: 'Ödeme güvenli mi?', a: '256-bit SSL şifreleme ve 3D Secure ile tüm ödemeler güvence altındadır. PCI DSS standartlarına uygun altyapı kullanıyoruz.' },
    ],
  },

  returnsPage: {
    title: 'İadelerim',
    subtitle: '30 gün içinde ücretsiz ve zahmetsiz iade',
    breadcrumb: 'İade Politikası',
    heroStat1Value: '30',
    heroStat1Label: 'Gün İade Süresi',
    heroStat2Value: 'Ücretsiz',
    heroStat2Label: 'İade Kargosu',
    heroStat3Value: '5-7',
    heroStat3Label: 'Gün Para İadesi',
    processTitle: 'İade Süreci',
    step1Num: '01',
    step1Title: 'İade Talebi Oluştur',
    step1Desc: 'E-posta veya canlı destek üzerinden sipariş numaranızla iade talebi oluşturun.',
    step2Num: '02',
    step2Title: 'Onay & Kargo Kodu',
    step2Desc: '24 saat içinde onay ve ücretsiz kargo kodu e-postanıza gönderilir.',
    step3Num: '03',
    step3Title: 'Ürünü Paketleyin',
    step3Desc: 'Ürünü orijinal ambalajında ve etiketleriyle birlikte paketleyin.',
    step4Num: '04',
    step4Title: 'Kargoya Teslim Edin',
    step4Desc: 'Verilen kargo kodu ile en yakın UPS noktasına teslim edin.',
    step5Num: '05',
    step5Title: 'Para İadenizi Alın',
    step5Desc: 'Ürün elimiz ulaştıktan sonra 5-7 iş günü içinde ödemeniz iade edilir.',
    eligibleTitle: 'İade Edilebilir Ürünler',
    elig1: 'Kullanılmamış ve orijinal ambalajında olan ürünler',
    elig2: 'Etiketleri sökülmemiş ürünler',
    elig3: 'Teslimattan itibaren 30 gün içinde talep edilen iadeler',
    elig4: 'İndirimli ürünler (aynı koşullar geçerlidir)',
    notEligibleTitle: 'İade Edilemeyen Ürünler',
    notElig1: 'Kişiselleştirilmiş (isim/yazı baskılı) ürünler',
    notElig2: 'Kullanılmış ve yıkanmış ürünler',
    notElig3: '30 günlük süreyi geçen talepler',
    notElig4: 'Ambalajı hasar görmüş ürünler',
    ctaTitle: 'İade Başlatmak İster Misiniz?',
    ctaText: 'Müşteri hizmetlerimiz size yardımcı olmaktan memnuniyet duyar.',
    ctaBtn: 'İade Talebi Oluştur',
  },

  shippingPage: {
    title: 'Kargo & Teslimat',
    subtitle: 'UPS ortaklığıyla güvenli, hızlı ve izlenebilir teslimat',
    breadcrumb: 'Kargo & Teslimat',
    upsBadge: 'Resmi UPS İş Ortağı',
    upsDesc: 'Dünya\'nın önde gelen kargo şirketi UPS ile çalışarak tüm siparişlerinizi güvenle teslim ediyoruz.',
    avgDelivery: '6 İş Günü',
    avgDeliveryLabel: 'Internasyon Ortalama Teslimat',
    trackingTitle: 'Gerçek Zamanlı Takip',
    trackingDesc: 'Her siparişiniz için UPS takip numarası sağlıyoruz. UPS\'in web sitesi, uygulaması veya SMS bildirimleriyle siparişinizi takip edebilirsiniz.',
    domesticTitle: 'Türkiye İçi Teslimat',
    domesticDesc: 'Türkiye genelinde tüm siparişlerde ücretsiz kargo. Siparişler 1-2 iş günü içinde hazırlanır.',
    dom1Title: 'Standart UPS Kargo',
    dom1Time: '3-5 İş Günü',
    dom1Price: 'Ücretsiz',
    dom2Title: 'UPS Ekspres',
    dom2Time: '1-2 İş Günü',
    dom2Price: '₺29,90',
    dom3Title: 'Aynı Gün (İstanbul)',
    dom3Time: 'Sipariş günü',
    dom3Price: '₺49,90',
    intlTitle: 'Uluslararası Teslimat',
    intlDesc: '50\'den fazla ülkeye UPS Uluslararası servisi ile teslimat yapıyoruz.',
    zoneEurope: 'Avrupa',
    zoneEuropeTime: '6-10 İş Günü',
    zoneEuropePrice: 'Ücretsiz (150€+) / 12€',
    zoneUSA: 'ABD & Kanada',
    zoneUSATime: '6-10 İş Günü',
    zoneUSAPrice: 'Ücretsiz (200$+) / 18$',
    zoneMiddleEast: 'Orta Doğu',
    zoneMiddleEastTime: '8-12 İş Günü',
    zoneMiddleEastPrice: '15$',
    zoneOther: 'Diğer Ülkeler',
    zoneOtherTime: '10-15 İş Günü',
    zoneOtherPrice: 'Lütfen İletişime Geçin',
    packagingTitle: 'Çevre Dostu Ambalaj',
    packagingDesc: 'Tüm siparişlerimizi %100 geri dönüştürülmüş ve biyobozunur ambalaj malzemeleriyle gönderiyoruz.',
    faqTitle: 'Kargo Hakkında S.S.S.',
    faq1Q: 'Siparişim ne zaman kargoya verilir?',
    faq1A: 'Siparişler genellikle 1-2 iş günü içinde hazırlanarak UPS\'e teslim edilir. Kargoya verildikten sonra e-posta ile bildirim yapılır.',
    faq2Q: 'UPS takip numaramı nasıl kullanabilirim?',
    faq2A: 'Kargo onay e-postasındaki takip numarasını ups.com adresine girerek veya UPS mobil uygulamasını kullanarak siparişinizi takip edebilirsiniz.',
    faq3Q: 'Teslimat adresimi değiştirebilir miyim?',
    faq3A: 'Sipariş kargoya verilmeden önce adres değişikliği yapabilirsiniz. Kargoya verildikten sonra UPS üzerinden adres güncelleme talebi açılabilir.',
    faq4Q: 'Sipariş teslim edilemezse ne olur?',
    faq4A: 'UPS teslimat yapılamazsa 3 kez deneme yapar. Başarısız olması durumunda en yakın UPS noktasına bırakır ve size bildirim gönderir.',
    ctaTitle: 'Kargo Hakkında Sorunuz Var Mı?',
    ctaText: 'Müşteri hizmetlerimizle 7/24 iletişime geçebilirsiniz.',
    ctaBtn: 'Canlı Destek',
  },

  favorites: {
    title: 'Favorilerim',
    itemsCount: 'ürün favorilenmiş',
    emptyTitle: 'Favori listeniz boş',
    emptySubtitle: 'Henüz favori ürün eklemediniz',
    emptyDesc: 'Beğendiğiniz ürünleri kalp ikonuna tıklayarak favorilere ekleyebilirsiniz. Üyelik gerekmez!',
    startShopping: 'Alışverişe Başla',
    clearAll: 'Tümünü Temizle',
    remove: 'Favoriden Çıkar',
    viewProduct: 'Ürünü Gör',
    suggestionsTitle: 'Keşfetmeye Başlayın',
    clearConfirmTitle: 'Tüm favoriler silinsin mi?',
    clearConfirmDesc: 'Bu işlem geri alınamaz. Tüm favori ürünleriniz silinecek.',
    clearConfirmBtn: 'Evet, Temizle',
    cancel: 'Vazgeç',
    addedToFavorites: 'Favorilere eklendi!',
    removedFromFavorites: 'Favorilerden çıkarıldı',
  },

  sizeGuide: {
    title: 'Beden Rehberi',
    subtitle: 'Doğru bedeni bulmak için karşılaştırın',
    infoNote: 'Emin değilseniz',
    infoHighlight: 'Geniş Kalıp\'ı',
    infoNoteEnd: 'tercih etmenizi öneririz — vücuda serbestçe oturur ve herkese uyum sağlar.',
    wideLabel: 'Geniş Kalıp',
    wideFit: 'Rahat & Özgür Hareket',
    wideDesc: 'Vücuda serbestçe oturan, nefes aldıran bir kesim. Günlük kullanım ve uzun günler için idealdir.',
    wideFeature1: 'Omuz ve kol bölgesinde ekstra alan',
    wideFeature2: 'Bel kısmı serbest, sıkmayan yapı',
    wideFeature3: 'Uzun süre konfor maksimum',
    wideFeature4: 'Hareketliliği kısıtlamaz',
    wideFeature5: 'Her vücut tipine uyum sağlar',
    wideBest: 'Günlük kullanım, seyahat, rahat giyim',
    narrowLabel: 'Dar Kalıp',
    narrowFit: 'Fitted & Şık Silüet',
    narrowDesc: 'Vücut hatlarını belirginleştiren, elegant ve yapılandırılmış bir kesim. Özel günler için mükemmel.',
    narrowFeature1: 'Omuz ve göğüs tam oturur',
    narrowFeature2: 'Bel kısmı vücudünüzü hafifçe sarar',
    narrowFeature3: 'Şık ve düzgün bir görünüm',
    narrowFeature4: 'Vücut hatlarını vurgular',
    narrowFeature5: 'İnce ve zarif bir siluet sunar',
    narrowBest: 'Özel davetler, iş toplantıları, akşam yemekleri',
    compareTitle: 'Hızlı Karşılaştırma',
    featureHeader: 'Özellik',
    compareWide: 'Geniş Kalıp',
    compareNarrow: 'Dar Kalıp',
    row1Label: 'Konfor', row1Wide: '⭐⭐⭐⭐⭐', row1Narrow: '⭐⭐⭐⭐',
    row2Label: 'Siluet', row2Wide: 'Akışkan & Serbest', row2Narrow: 'Belirgin & Fitted',
    row3Label: 'Hareket Özgürlüğü', row3Wide: 'Maksimum', row3Narrow: 'Orta',
    row4Label: 'Önerilen Kullanım', row4Wide: 'Günlük & Casual', row4Narrow: 'Özel & Resmi',
    row5Label: 'Beden Uyumu', row5Wide: 'Her vücut tipine', row5Narrow: 'Tercih ve vücuda göre',
    bestLabel: 'En iyi:',
    liveSupportText: 'Hangi kalıbın size uygun olduğundan emin değilseniz',
    liveSupportLink: 'canlı destek',
    liveSupportEnd: 'hattımızdan yardım alabilirsiniz.',
    shoe: {
      title: 'Ayakkabı Kalıbı',
      subtitle: 'Parmak genişliğine göre doğru kalıbı seçin',
      infoNote: 'Barefoot ayakkabılarımız',
      infoHighlight: 'anatomik kalıp',
      infoNoteEnd: 'ile üretilmiştir — parmaklar doğal pozisyonunda serbestçe durur.',
      barefootLabel: 'Barefoot Kalıp',
      barefootTagline: 'Anatomik & Geniş Taban',
      barefootDesc: 'Parmak kutusu geniş, ayağınıza tam uyan barefoot kalıp. Parmaklar sıkışmaz, doğal yayılır.',
      barefootF1: 'Parmak kutusu en geniş alan',
      barefootF2: 'Parmaklar serbestçe hareket eder',
      barefootF3: 'Uzun süre konfor maksimum',
      barefootF4: 'Doğal ayak postürünü destekler',
      barefootBest: 'Günlük kullanım, seyahat, rahat giyim',
      standartLabel: 'Standart Kalıp',
      standartTagline: 'Normal & Dengeli Taban',
      standartDesc: 'Klasik dengeli kesim. Parmak kutusu orta genişlikte, genel ayak tipine uygun.',
      standartF1: 'Orta genişlikte parmak kutusu',
      standartF2: 'Geniş kitleye uyum sağlar',
      standartF3: 'Şık ve günlük kullanıma uygun',
      standartF4: 'Öneğinizi daha dar parmaklar için ideal',
      standartBest: 'Günlük, iş, sosyal kullanım',
      darLabel: 'Dar Standart',
      darTagline: 'Dar & Şık Siluet',
      darDesc: 'Parmak kutusu dar, fitted kesim. İnce ve uzun ayaklar için özel olarak tasarlanmış.',
      darF1: 'Parmak kutusu en dar alan',
      darF2: 'İnce ayak tipine tam oturur',
      darF3: 'Elegant ve şık görünüm',
      darF4: 'Özel davetler için ideal',
      darBest: 'Özel günler, resmi toplantılar',
      toeGenis: 'Parmak: Geniş',
      toeNormal: 'Parmak: Normal',
      toeDar: 'Parmak: Dar',
      compareTitle: 'Kalıp Şekli Karşılaştırması',
      cmpToe: 'Parmak Kutusu',
      cmpToeBarefoot: 'Çok Geniş',
      cmpToeStandart: 'Orta',
      cmpToeDar: 'Dar',
      cmpConfort: 'Konfor',
      cmpUse: 'Kullanım',
      cmpUseBarefoot: 'Günlük & Aktif',
      cmpUseStandart: 'Günlük & Şık',
      cmpUseDar: 'Özel & Resmi Günler',
      cmpFit: 'Ayak Tipi',
      cmpFitBarefoot: 'Her tip, geniş taban',
      cmpFitStandart: 'Standart ayak',
      cmpFitDar: 'İnce & uzun ayak',
    },
  },

  sizeGuideAudio: {
    listenBtn: 'Sesli Rehber',
    stopBtn: 'Durdur',
    bannerDesc: 'Ölçüm talimatlarını sesli dinleyin',
    playingLabel: 'Sesli rehber oynat\u0131l\u0131yor...',
    stopDesc: 'Durdurmak için tıklayın',
    shoeNarration: 'Lütfen çıplak ayağınızın uzunluğunu santimetre cinsinden ölçün. Soğuk suda, hassas programda yıkayın',
    clothingNarration: 'Göğüs, bel, kalça ve boyunuzu santimetre cinsinden ölçün. Göğsü kolların altında en geniş noktadan, beli en dar noktadan, kalçayı ise en geniş noktadan ölçün. Ölçümlerinizi esnek mezura ile yapın.',
  },

  returnPolicyAudio: {
    lang: 'tr-TR',
    listenBtn: 'Sesli rehberi dinle',
    stopBtn: 'Durdur',
    desc: 'İade & değişim politikasını dinleyin',
    playingDesc: 'Sesli anlatım oynatılıyor...',
    narration: 'Merhaba! Size FentyBarefoot iade ve değişim politikamızı sesli olarak anlatmak istiyoruz. Teslim aldığınız tarihten itibaren tam otuz gün içinde, hiçbir ücret ödemeden ürünlerinizi iade edebilirsiniz. Tüm iade kargo ücretleri tarafımızca karşılanmaktadır. İade ettiğiniz ürün bize ulaştıktan sonra beş ila yedi iş günü içinde ödemeniz, orijinal ödeme yönteminize tam olarak iade edilir. Beden veya renk değişikliği yapmak istiyorsanız, ücretsiz değişim hakkınızı kullanabilirsiniz. İade veya değişim yapılabilmesi için ürünün kullanılmamış, etiketleri sökülmemiş ve orijinal ambalajında olması gerekmektedir. Herhangi bir sorunuz olursa, yedi gün yirmi dört saat canlı destek hattımız her zaman yanınızda. Teşekkür ederiz!',
  },

  ugcGallery: {
    badge: 'Müşteri Fotoğrafları',
    title: 'Sizden Gelenler',
    subtitle: 'Dünyanın dört bir yanından müşterilerimizin gözünden FentyBarefoot — gerçek insanlar, gerçek anlar.',
    shareText: 'Siz de FentyBarefoot deneyiminizi paylaşın!',
    shareBtn: '#FentyBarefoot ile Paylaş',
    prevBtn: 'Önceki',
    nextBtn: 'Sonraki',
  },

  podiatristSection: {
    title: 'Ayak Hekimlerinden Uzman Görüşleri',
    subtitle: 'Dünyaca tanınan podiyatri uzmanları, FentyBarefoot topraklama teknolojisinin bilimsel etkilerini ve klinik gözlemlerini paylaşıyor.',
    listenBtn: 'Sesli Dinle',
    stopBtn: 'Durdur',
    statDoctors: 'Uzman Doktor',
    statStudies: 'Klinik Çalışma',
    statPatients: 'Hasta Gözlemi',
    disclaimer: 'Uzman görüşleri kişisel klinik deneyimlere dayalıdır. Bireysel sonuçlar farklılık gösterebilir.',

    doctor1Name: 'Dr. Mehmet Yılmaz',
    doctor1Title: 'Podiyatri Uzmanı | İstanbul Tıp Fakültesi',
    doctor1Quote: 'Topraklama, sadece bir adım değil — doğayla kurduğun gerçek bir bağdır. Her hasta bunu deneyimlediğinde dönüşümü hissedebiliyorum.',
    doctor1Narration: 'Barefoot topraklama ayakkabıları, seni doğanın özüne geri götürmek için tasarlandı. Modern yaşamın yalıtılmış tabanları yerine, doğal temasın gücünü hissedersin. Bakır iletken detaylar sayesinde, toprağın enerjisi doğrudan bedenine ulaşır. Negatif yükler dengelenir, bedenin doğal ritmine kavuşur. Topraklama… Sadece yürümek değil, hissetmektir. Sadece adım atmak değil, dünya ile bağ kurmaktır. Ruhun sakinleşir, bedenin hafifler… Her adımda daha dengeli, daha enerjik hissedersin. Doğal. Saf. Gerçek. Barefoot topraklama botlarıyla, enerjini yeniden keşfet.',

    doctor2Name: 'Dr. Sarah Johnson',
    doctor2Title: 'Ayak & Bilek Uzmanı | London Foot Clinic',
    doctor2Quote: 'Ayaklarınız vücudunuzun en ihmal edilen organlarıdır. Barefoot felsefesi onlara hak ettikleri özgürlüğü geri veriyor.',
    doctor2Narration: 'Ayak biyomekaniği, modern ayakkabı endüstrisinin en çok ihmal ettiği alandır. Geleneksel ayakkabılar, ayağın yirmi altı kemiğini, otuz üç eklemini ve sonrasında fazla kasını pasif hale getirir. Bu, kasların zayıflamasına ve dengenin bozulmasına yol açar. Barefoot tasarım ise farklı bir hikaye anlatır. Geniş parmak kutusu, parmakların anatomik pozisyonunda doğal olarak yayılmasını sağlar. Minimal taban propriyosepsiyonu artırarak denge ve koordinasyonu iyileştirir. Ayak, baldır ve kalça kasları daha doğal çalışarak zamanla güçlenir. Eklem üzerindeki baskı azalarak uzun vadede diz ve kalça sağlığını destekler. Topraklama ise buna başka bir boyut ekler. Her adımınızda zeminden gelen elektriksel sinyaller sinir sistemini dengeler. Bu etki, kronik ağrı hastalarında on iki hafta boyunca topraklama ayakkabısı kullanan hastalarda kortizol seviyesiinde yüzde yirmi sekiz düştü. Uyku kalitesi belirgin biçimde iyileşti. İltihaplanma belirteçleri anlamlı azaldı. Organik malzemeler, bakır iletkenler, barefoot tasarım… Bunların birleşimi bilim devreye girmeden doğanın mükemmel işbirliğidir.',
  },
  groundingAudio: {
    badge: 'Topraklama Felsefesi',
    title: 'Topraklama Etkisinin Sesli Anlatımı',
    subtitle: 'Ölçüm talimatlarını sesli dinleyin',
    listenBtn: 'Sesli Dinle',
    stopBtn: 'Durdur',
    bannerDesc: 'Ölçüm talimatlarını sesli dinleyin',
    playingLabel: 'Sesli rehber oynat\u0131l\u0131yor...',
    stopDesc: 'Durdurmak için tıklayın',
    narration: 'Toprak… insan bedeninin en eski ve en güçlü enerji kaynağıdır. Binlerce yıl boyunca insanlar çıplak ayakla yürüdü, doğayla temas halinde yaşadı. Ancak modern yaşam… bu doğal bağı büyük ölçüde kopardı. İşte tam bu noktada, grounding barefoot ayakkabıların ardındaki bilim devreye giriyor. Grounding yani earthing kavramı, ayağınız ile yeryüzü arasında doğrudan bir enerji köprüsü kurmak için tasarlanmıştır. Bu özel tasarımın kalbinde ise bakır bulunur. Bakır, doğanın en iyi iletkenlerinden biridir. Elektriksel yükleri taşıma kapasitesi sayesinde… vücudunuzda biriken statik elektriği toprağa aktarır ve dünyanın doğal negatif elektronlarıyla temas etmenizi sağlar. Bu süreçte ne olur? Vücudunuz… doğal dengesine geri dönmeye başlar. Topraklama etkisiyle; stres ve gerginlik azalabilir, uyku kalitesi artabilir, kas ve eklem rahatlaması sağlanabilir, kan dolaşımı desteklenebilir, enerji seviyesinde gözle görülür artış hissedilebilir. Barefoot yani çıplak ayak tasarımı ise sadece enerjiyle sınırlı değildir. Geniş burun yapısı sayesinde ayak parmaklarınız doğal olarak yayılır. İnce ve esnek taban, zemini hissetmenizi sağlar. Ayağınız… olması gerektiği gibi hareket eder. Çünkü insan ayağı, desteklenmek için değil… doğal olarak çalışmak için yaratılmıştır. Grounding ayakkabıların tabanında bulunan iletken bakır noktalar, her adımınızda toprağa temas ederek bedeniniz ile dünya arasında kesintisiz bir bağlantı kurar. Bu sadece bir ayakkabı değil… bu, doğaya geri dönüşün bir yoludur. Her adımda… toprağın enerjisini hissedin. Dengeyi hissedin. Doğayı hissedin. Grounding barefoot ayakkabılar ile yeniden bağlanın. Topraklama ve çıplak ayakla yürümenin onarıcı şifa gücünü keşfedin. Dünya yüzeyinden gelen sürekli faydalı elektron akışına bağlanarak, bu bağlantı vücudunuzun doğal iyileşme ve yenilenme süreçlerini destekler ve günlük yaşamınızda optimum sağlık ve esenliği teşvik eder.',
  },
  wholesalePage: {
    pageTitle: 'Toptan Satış Portalı',
    pageSubtitle: 'FentyBarefoot Bayi & Toptan Alım Merkezi',
    heroBadge: 'Yetkili Bayi Programı',
    heroTitle: 'Toptan Ürün Kataloğu',
    heroDesc: 'Grounding barefoot ürünlerimizi toptan sipariş edin. 50 adet ve üzeri siparişlerde özel toptan fiyatları geçerlidir.',
    loginTitle: 'Bayi Girişi',
    loginSubtitle: 'Toptan fiyatları görmek için giriş yapın',
    loginUsername: 'Kullanıcı Adı',
    loginPassword: 'Şifre',
    loginBtn: 'Giriş Yap',
    loginError: 'Hatalı kullanıcı adı veya şifre',
    logoutBtn: 'Çıkış Yap',
    loggedInAs: 'Giriş yapıldı:',
    priceHidden: 'Fiyatı Görmek İçin Giriş Yapın',
    priceHiddenShort: 'Bayi Girişi Gerekli',
    unlockPrices: 'Fiyatları Görmek İçin Bayi Girişi Yapın',
    filterAll: 'Tümü',
    filterWomen: 'Kadın',
    filterMen: 'Erkek',
    filterUnisex: 'Unisex',
    filterShoes: 'Ayakkabı',
    filterClothing: 'Giyim',
    categoryLabel: 'Kategori',
    genderLabel: 'Cinsiyet',
    qty50: '50 Adet',
    qty100: '100 Adet',
    qty500: '500 Adet',
    qtyLabel: 'Sipariş Adedi',
    pricePerUnit: 'Birim Fiyat',
    totalPrice: 'Toplam Fiyat',
    requestBtn: 'Talepte Bulun',
    requestNote: 'Adete göre fiyat belirlenir. Teklif talebinizi iletiyorsunuz.',
    requestModalTitle: 'Toptan Talep Formu',
    requestModalDesc: 'Seçtiğiniz ürün için toptan sipariş talebinizi iletin.',
    requestProduct: 'Ürün',
    requestQty: 'Adet',
    requestName: 'Ad Soyad',
    requestEmail: 'E-posta',
    requestPhone: 'Telefon',
    requestCompany: 'Şirket Adı',
    requestMessage: 'Notlarınız',
    requestSend: 'Talebi Gönder',
    requestClose: 'Kapat',
    requestSuccess: 'Talebiniz iletildi! En kısa sürede sizinle iletişime geçeceğiz.',
    stockInfo: 'Stok',
    material: 'Materyal',
    sizes: 'Bedenler',
    colors: 'Renkler',
    images: 'Görseller',
    priceTierTitle: 'Toptan Fiyat Kademeleri',
    priceTier50: '50+ adet',
    priceTier100: '100+ adet',
    priceTier500: '500+ adet',
    sortBy: 'Sıralama',
    sortDefault: 'Varsayılan',
    sortPriceLow: 'Fiyat: Düşükten Yükseğe',
    sortPriceHigh: 'Fiyat: Yüksekten Düşüğe',
    discountDesc: 'İndirim: Yüksekten Düşüğe',
    newest: 'En Yeni',
    productsOnSale: 'İndirimli Ürün',
    totalDiscount: 'Toplam İndirim',
    happyCustomers: 'Mutlu Müşteri',
    freeShipping: 'Ücretsiz Kargo',
    banner1Title: 'Sezonun En İyi Fırsatları',
    banner1Subtitle: 'Tüm kategorilerde %70\'e varan indirimler',
    banner2Title: 'Son Saatler!',
    banner2Subtitle: 'Kaçırmadan sepetine ekle',
    // Countdown
    flashRound: 'Flaş İndirim',
    flashBadge: '⚡ FLAŞ',
    dailyRound: 'Günün Fırsatı',
    dailyBadge: '🔥 GÜNÜN',
    nightRound: 'Gece Kampanyası',
    nightBadge: '🌙 GECE',
    newCampaignStarted: 'Yeni Kampanya Başladı!',
    dontMiss: 'Kaçırma!',
    nextCampaign: 'Sonraki:',
    hours: 'SAAT',
    minutes: 'DAKİKA',
    seconds: 'SANİYE',
    // SaleProductCard
    discount: 'İNDİRİM',
    reviews: 'değerlendirme',
    stockStatus: 'Stok Durumu',
    stockLeft: 'adet kaldı!',
  },

  footerNotif: {
    liveBadge: 'Canlı Bildirimler',
    paused: '⏸ Duraklatıldı',
    liveStatus: '▶ Canlı',
    buyAction: 'satın aldı',
    favAction: 'favorilere ekledi',
    cartStatAction: 'kişinin sepetinde',
    favStatAction: 'kişi favorilere ekledi',
    labelBuy: 'Satın Aldı',
    labelFav: 'Favorilere Ekledi',
    labelCart: 'Sepete Ekledi',
    labelLive: 'Canlı',
    justNow: 'Az önce',
    min1: '1 dk önce',
    min2: '2 dk önce',
    min3: '3 dk önce',
    min5: '5 dk önce',
    min7: '7 dk önce',
    prod1: 'Altın Hasır Sandalet',
    prod2: 'Deri Mule Terlik',
    prod3: 'Boho Maxi Elbise',
    prod4: 'Strappy Topuklu Sandalet',
    prod5: 'Keten Wrap Elbise',
    prod6: 'Platform Sandalet',
    prod7: 'Vegan Deri Terlik',
    prod8: 'Çiçekli Midi Elbise',
    prod9: 'Erkek Sandalet',
    prod10: 'Erkek Keten Gömlek',
    prod11: 'Hasır Düz Sandalet',
    prod12: 'Kordone Sandalet',
    prod13: 'Topuklu Mule',
    prod14: 'Altın Bileklik Seti',
    prod15: 'Yaz Kombin Seti',
    prod16: 'Erkek Yaz Kombini',
    prod17: 'Deri Çanta + Sandalet',
    prod18: 'Boho Çanta + Terlik',
    prod19: 'Yazlık Elbise Kombin',
    prod20: 'Plaj Seti',
    prod21: 'Renkli Bikini Seti',
    prod22: 'Hasır Plaj Çantası',
    prod23: 'Güneş Gözlüğü',
    prod24: 'Pamuklu Yazlık Elbise',
    prod25: 'Deri Kemer',
    prod26: 'Örgü Sandalet',
    prod27: 'Çiçekli Bluz',
    prod28: 'Keten Şort',
    prod29: 'Gümüş Kolye',
    prod30: 'Rattan Çanta',
  },

  memberPanel: {
    breadcrumbHome: 'Ana Sayfa',
    breadcrumbPanel: 'Üye Paneli',
    loading: 'Yükleniyor...',
    memberSince: 'Üyelik:',
    menu: 'Menü',
    logout: 'Çıkış Yap',
    logoutConfirmTitle: 'Çıkış yapmak istiyor musunuz?',
    logoutConfirmDesc: 'Hesabınızdan güvenli şekilde çıkış yapılacak.',
    logoutCancel: 'İptal',
    tabOrders: 'Siparişlerim',
    tabReturns: 'İadelerim',
    tabCoupons: 'İndirim Kuponlarım',
    tabSupport: 'Destek Taleplerim',
    tabInvoices: 'Faturalarım',
    tabAddress: 'Adreslerim',
    tabProfile: 'Profilim',
    ordersTitle: 'Siparişlerim',
    ordersCount: '{{count}} sipariş bulundu',
    statusDelivered: 'Teslim Edildi',
    statusShipped: 'Kargoda',
    statusProcessing: 'Hazırlanıyor',
    statusCancelled: 'İptal Edildi',
    qty: 'Adet:',
    deliveryInfo: 'Teslimat Bilgileri',
    paymentInfo: 'Ödeme Bilgileri',
    addressLabel: 'Adres:',
    city: 'Şehir',
    cityPlaceholder: 'İstanbul',
    postalCode: 'Posta Kodu',
    postalCodePlaceholder: '34000',
    country: 'Ülke',
    orderNote: 'Sipariş Notu',
    orderNoteOptional: '(İsteğe bağlı)',
    orderNotePlaceholder: 'Siparişinizle ilgili özel bir notunuz varsa buraya yazabilirsiniz...',
    saveAddressLabel: 'Bu adresi bir sonraki sipariş için kaydet',
    savedAddressTitle: 'Kayıtlı Adresiniz',
    useSavedAddress: 'Kayıtlı Adresi Kullan',

    // Order Summary
    orderSummaryTitle: 'Sipariş Özeti',
    products: 'ürün',
    emptyCartMsg: 'Sepetiniz boş',
    discountCode: 'İndirim Kodu',
    couponPlaceholder: 'KODU GİRİN',
    couponApplied: '%10 indirim uygulandı!',
    couponAutoApplied: 'Kupon kodu otomatik uygulandı!',
    couponAutoAppliedDesc: 'kodu indiriminize yansıtıldı.',
    couponHowToTitle: 'Kupon Nasıl Kullanılır?',
    couponHowToDesc: 'Ödeme sayfasında "İndirim Kodu" alanına kupon kodunuzu girin ve "Uygula" butonuna tıklayın. İndirim sepet toplamına otomatik uygulanır.',
    couponMinOrder: 'Bu kupon için minimum sipariş tutarı {{amount}}',
    couponMinOrderDesc: 'Bu kupon kodu kullanmak için siparişiniz minimum {{amount}} olmalıdır.',
    errCouponMinOrder: 'Bu kupon için minimum sipariş tutarı {{amount}}',
    couponApplicable: 'Uygulanabilir',
    applyCouponToCart: 'Sepete Uygula',
    cartApplicableCoupons: 'Sepetinize Uygulanabilir Kuponlar',
    cartApplicableDesc: 'Güncel sepet tutarınız ({{total}}) için kullanılabilir kuponlar',
    subtotal: 'Ara Toplam',
    shipping: 'Kargo',
    free: 'Ücretsiz',
    discount: 'İndirim',
    total: 'Toplam',
    vatIncluded: 'KDV dahil',
    sslSecure: 'SSL Güvenli',
    easyReturn: 'Kolay İade',
    qty: 'Adet',

    // Success Page
    successTitle: 'Siparişiniz Alındı! 🎉',
    successSubtitle: 'Teşekkürler! Siparişiniz başarıyla oluşturuldu ve hazırlanmaya başlandı.',
    orderNumberLabel: 'Sipariş Numaranız',
    orderNumberNote: 'Bu numarayı not alın, sipariş takibinde kullanabilirsiniz.',
    estimatedDelivery: 'Tahmini teslimat',
    businessDays: 'İş Günü',
    paymentLabel: 'Ödeme',
    confirmEmail: 'Onay E-postası',
    confirmEmailSent: 'Gönderildi',
    orderDetails: 'Sipariş Detayları',
    deliveryAddress: 'Teslimat Adresi',
    orderProcess: 'Sipariş Süreci',
    stepReceived: 'Sipariş Alındı',
    stepPreparing: 'Hazırlanıyor',
    stepShipped: 'Kargoya Verildi',
    stepDelivered: 'Teslim Edildi',
    backHome: 'Ana Sayfaya Dön',
    continueShopping: 'Alışverişe Devam',
    contactUs: 'müşteri hizmetlerimizle',
    contactNote: 'Sorularınız için',
    contactEnd: 'iletişime geçebilirsiniz.',
    paymentCreditCard: 'Kredi Kartı',
    paymentTransfer: 'Havale/EFT',

    // Footer
    footerTagline: 'Güvenli alışveriş garantisi',
    footerContact: 'İletişim',
    footerShipping: 'Kargo Bilgisi',
    footerReturns: 'İade Politikası',
    footerSsl: '256-bit SSL Güvenli Ödeme',
  },
  redirectingToCheckout: 'Ödeme sayfasına yönlendiriliyorsunuz...',

  story: {
    swipeHint: 'Kaydır',
    productTaggedLabel: 'ürün etiketlendi — dokunarak keşfet',
    goToProduct: 'Ürüne Git',
    discountLabel: 'indirim',
    followInstagram: "Instagram'da Takip Et • @fentybarefoot",
    stories: {
      s1: { title: '🔥 En Çok Satanlar', subtitle: "Haftanın süperstars'ları burada — kaçırma!", badge: 'SÜPER SELLER', cta: 'Popüler Ürünleri Gör' },
      s2: { title: '✨ 2026 Yeni Sezon Sandaletler', subtitle: 'El işçiliğiyle üretilen yeni koleksiyon geldi', badge: '2026 YENİ SEZON', cta: 'Kadın Sandaletleri' },
      s3: { title: '👗 Kadın Koleksiyonu', subtitle: 'Şıklığı özgürlükle birleştir', badge: 'KOLEKSİYON', cta: 'Kadın Giyim' },
      s4: { title: ' SALE İndirim', subtitle: "%70'e kadar indirim — stoklar tükeniyor!", badge: '%70 İNDİRİM', cta: 'İndirimleri Kaçırma' },
      s5: { title: '👟 Erkek Koleksiyonu', subtitle: 'Modern erkek tarzı — doğal ve rahat', badge: 'ERKEK', cta: 'Erkek Ürünleri' },
      s6: { title: '🌿 Sürdürülebilir Moda', subtitle: 'Doğa dostu üretim, lüks his', badge: 'EKO', cta: 'Hikayemizi Oku' },
      s7: { title: '👜 Aksesuar & Çanta', subtitle: 'Tarzını tamamlayan detaylar', badge: 'YENİ', cta: 'Aksesuar Koleksiyonu' },
      s8: { title: '🎁 Kombo Setler', subtitle: 'Birlikte daha avantajlı — özel fiyatlı setler', badge: 'KOMBO FIRSAT', cta: 'Komboları İncele' },
      s9: { title: "📸 Instagram'da Biz", subtitle: '@fentybarefoot — Topluluğumuza katıl', badge: 'SOSYAL', cta: "Instagram'da Takip Et" },
    },
  },

  search: {
    placeholder: 'Ürün ara... (örn. sandalet, bot, elbise)',
    noResults: 'Sonuç bulunamadı',
    viewAll: '"{{query}}" ile ilgili tüm ürünleri gör',
    title: 'Ürün Ara',
    shortLabel: 'Ara',
    close: 'Kapat',
    popular: 'Popüler Aramalar',
    resultsLabel: 'Bulunan Ürünler',
    popularTerms: ['Sandalet', 'Bot', 'Elbise', 'Terlik', 'Kombin'],
    searchPage: {
      resultsCount: 'ürün bulundu',
      searchDesc: 'Aradığınız ürünü bulun',
      sortBy: 'Sıralama',
      sortDefault: 'Varsayılan',
      sortPriceLow: 'Fiyat: Düşükten Yükseğe',
      sortPriceHigh: 'Fiyat: Yüksekten Düşüğe',
      sortDiscount: 'En Yüksek İndirim',
      viewProduct: 'Ürünü Gör',
      tryOtherTerms: 'Farklı bir arama terimi deneyin',
      loadMore: 'Daha Fazla Yükle',
    },
  },

  fitGuide: {
    title: 'Kalıp Rehberi',
    subtitle: 'Doğru bedeni bulmak için karşılaştırın',
    infoNote: 'Emin değilseniz',
    infoHighlight: 'Geniş Kalıp\'ı',
    infoNoteEnd: 'tercih etmenizi öneririz — vücuda serbestçe oturur ve herkese uyum sağlar.',
    wideLabel: 'Geniş Kalıp',
    wideFit: 'Rahat & Özgür Hareket',
    wideDesc: 'Vücuda serbestçe oturan, nefes aldıran bir kesim. Günlük kullanım ve uzun günler için idealdir.',
    wideFeature1: 'Omuz ve kol bölgesinde ekstra alan',
    wideFeature2: 'Bel kısmı serbest, sıkmayan yapı',
    wideFeature3: 'Uzun süre konfor maksimum',
    wideFeature4: 'Hareketliliği kısıtlamaz',
    wideFeature5: 'Her vücut tipine uyum sağlar',
    wideBest: 'Günlük kullanım, seyahat, rahat giyim',
    narrowLabel: 'Dar Kalıp',
    narrowFit: 'Fitted & Şık Silüet',
    narrowDesc: 'Vücut hatlarını belirginleştiren, elegant ve yapılandırılmış bir kesim. Özel günler için mükemmel.',
    narrowFeature1: 'Omuz ve göğüs tam oturur',
    narrowFeature2: 'Bel kısmı vücudünüzü hafifçe sarar',
    narrowFeature3: 'Şık ve düzgün bir görünüm',
    narrowFeature4: 'Vücut hatlarını vurgular',
    narrowFeature5: 'İnce ve zarif bir siluet sunar',
    narrowBest: 'Özel davetler, iş toplantıları, akşam yemekleri',
    compareTitle: 'Hızlı Karşılaştırma',
    featureHeader: 'Özellik',
    compareWide: 'Geniş Kalıp',
    compareNarrow: 'Dar Kalıp',
    row1Label: 'Konfor', row1Wide: '⭐⭐⭐⭐⭐', row1Narrow: '⭐⭐⭐⭐',
    row2Label: 'Siluet', row2Wide: 'Akışkan & Serbest', row2Narrow: 'Belirgin & Fitted',
    row3Label: 'Hareket Özgürlüğü', row3Wide: 'Maksimum', row3Narrow: 'Orta',
    row4Label: 'Önerilen Kullanım', row4Wide: 'Günlük & Casual', row4Narrow: 'Özel & Resmi',
    row5Label: 'Beden Uyumu', row5Wide: 'Her vücut tipine', row5Narrow: 'Tercih ve vücuda göre',
    bestLabel: 'En iyi:',
    liveSupportText: 'Hangi kalıbın size uygun olduğundan emin değilseniz',
    liveSupportLink: 'canlı destek',
    liveSupportEnd: 'hattımızdan yardım alabilirsiniz.',
    shoe: {
      title: 'Ayakkabı Kalıbı',
      subtitle: 'Parmak genişliğine göre doğru kalıbı seçin',
      infoNote: 'Barefoot ayakkabılarımız',
      infoHighlight: 'anatomik kalıp',
      infoNoteEnd: 'ile üretilmiştir — parmaklar doğal pozisyonunda serbestçe durur.',
      barefootLabel: 'Barefoot Kalıp',
      barefootTagline: 'Anatomik & Geniş Taban',
      barefootDesc: 'Parmak kutusu geniş, ayağınıza tam uyan barefoot kalıp. Parmaklar sıkışmaz, doğal yayılır.',
      barefootF1: 'Parmak kutusu en geniş alan',
      barefootF2: 'Parmaklar serbestçe hareket eder',
      barefootF3: 'Uzun süre konfor maksimum',
      barefootF4: 'Doğal ayak postürünü destekler',
      barefootBest: 'Günlük kullanım, seyahat, rahat giyim',
      standartLabel: 'Standart Kalıp',
      standartTagline: 'Normal & Dengeli Taban',
      standartDesc: 'Klasik dengeli kesim. Parmak kutusu orta genişlikte, genel ayak tipine uygun.',
      standartF1: 'Orta genişlikte parmak kutusu',
      standartF2: 'Geniş kitleye uyum sağlar',
      standartF3: 'Şık ve günlük kullanıma uygun',
      standartF4: 'Öneğinizi daha dar parmaklar için ideal',
      standartBest: 'Günlük, iş, sosyal kullanım',
      darLabel: 'Dar Standart',
      darTagline: 'Dar & Şık Siluet',
      darDesc: 'Parmak kutusu dar, fitted kesim. İnce ve uzun ayaklar için özel olarak tasarlanmış.',
      darF1: 'Parmak kutusu en dar alan',
      darF2: 'İnce ayak tipine tam oturur',
      darF3: 'Elegant ve şık görünüm',
      darF4: 'Özel davetler için ideal',
      darBest: 'Özel günler, resmi toplantılar',
      toeGenis: 'Parmak: Geniş',
      toeNormal: 'Parmak: Normal',
      toeDar: 'Parmak: Dar',
      compareTitle: 'Kalıp Şekli Karşılaştırması',
      cmpToe: 'Parmak Kutusu',
      cmpToeBarefoot: 'Çok Geniş',
      cmpToeStandart: 'Orta',
      cmpToeDar: 'Dar',
      cmpConfort: 'Konfor',
      cmpUse: 'Kullanım',
      cmpUseBarefoot: 'Günlük & Aktif',
      cmpUseStandart: 'Günlük & Şık',
      cmpUseDar: 'Özel & Resmi Günler',
      cmpFit: 'Ayak Tipi',
      cmpFitBarefoot: 'Her tip, geniş taban',
      cmpFitStandart: 'Standart ayak',
      cmpFitDar: 'İnce & uzun ayak',
    },
  },

  careGuide: {
    tabDescription: 'Ürün Açıklaması',
    tabMaterial: 'Kumaş Bilgisi',
    tabCare: 'Bakım Talimatları',
    tabLeather: 'Deri Bakımı',
    tabSole: 'Taban Özellikleri',
    compositionTitle: 'Malzeme Bileşimi',
    mainFabricLabel: 'Ana Kumaş',
    mainFabricVal: '%100 Organik Keten',
    liningLabel: 'Astar',
    liningVal: '%100 Organik Pamuk',
    certLabel: 'Sertifikasyon',
    certVal: 'GOTS Sertifikalı Organik',
    propertiesTitle: 'Kumaş Özellikleri',
    prop1: 'Nefes alabilir ve hafif yapı',
    prop2: 'Nem emici özellik',
    prop3: 'Doğal iplik yapısı, hipoalerjenik',
    prop4: 'UV dayanımlı, uzun ömürlü',
    prop5: 'Çevre dostu, doğal kaynaklı',
    washLabel: 'Yıkama',
    washVal: '30°C Hassas',
    washNote: 'Soğuk suda, hassas programda yıkayın',
    dryLabel: 'Kurutma',
    dryVal: 'Asarak Kurutun',
    dryNote: 'Gölgede, doğal ortamda kurutun',
    ironLabel: 'Ütüleme',
    ironVal: 'Orta Isı ••',
    ironNote: 'Nemli bezle veya buharlı ütüleyin',
    bleachLabel: 'Ağartma',
    bleachVal: 'Klorsuz Deterjan',
    bleachNote: 'Oksijen bazlı, hafif deterjan kullanın',
    dryCleanLabel: 'Kuru Temizleme',
    dryCleanVal: 'Tavsiye Edilmez',
    dryCleanNote: 'Kuru temizleme yapmayın',
    tipsTitle: 'Uzman Bakım İpuçları',
    tip1: 'İlk yıkamada hafif renk akması olabilir, ayrı yıkayın',
    tip2: 'Keten kumaşta hafif kırışıklık normaldir — buharlı ütüleyin',
    tip3: 'Derin renkleri ters yüz çevirerek yıkayın',
    tip4: 'Makine kurutucuya koymayın, şekil bozulabilir',
    orgCertNote: 'GOTS Sertifikası nedir?',
    orgCertDesc: 'Global Organic Textile Standard — tekstil endüstrisinin en katı organik standardı. Tüm üretim sürecini kapsar.',
    // Leather Care
    leatherWarningTitle: 'Deri Taban Uyarısı',
    leatherWarningText: 'Deri taban aşırı ısulu ortama gelmez. Yağmur, su birikintisi ve nemli zeminlerle uzun süreli temas derinin zarar görmesine ve şekil bozulmasına neden olabilir.',
    rubberTitleSection: 'Kauçuk Taban — Her Koşulda Güvenli',
    rubberDesc: 'Kauçuk taban suya, kışa, soğa ve sert zeminlerde dayanıklıdır. Yağmurlu havalar, karlı yollar ve zorlu araziler için mükemmel seçimdir.',
    leatherCare1Label: 'Nem',
    leatherCare1Val: 'Koruyun',
    leatherCare1Note: 'Yağmur ve suda bekletmeyin',
    leatherCare2Label: 'Temizlik',
    leatherCare2Val: 'Nemli Bezle',
    leatherCare2Note: 'Sert deterjan kullanmayın',
    leatherCare3Label: 'Depolama',
    leatherCare3Val: 'Hava Alan Yer',
    leatherCare3Note: 'Direkt güneş ışığından uzak',
    leatherCare4Label: 'Bakım Yağı',
    leatherCare4Val: 'Tavsiye Edilir',
    leatherCare4Note: 'Deri besleyici krem sürün',
    leatherCare5Label: 'Kurutma',
    leatherCare5Val: 'Doğal Ortamda',
    leatherCare5Note: 'Ateş veya fön kullanmayın',
    leatherTipsTitle: 'Deri Bakım İpuçları',
    leatherTip1: 'Islanan deriyi doğrudan ısıya maruz bırakmayın, gölgede doğal ortamda kurutun',
    leatherTip2: 'Ayda bir deri bakım kremi veya doğal yağ sürerek nem ve parlaklığını koruyun',
    leatherTip3: 'Kullanmadığınız zamanlarda toz torbasına koyun, şeki ve yüzeyi korunur',
    leatherTip4: 'Leke oluşunca hemen nemli bezle silin, kalıcı iz bırakmaz',
    // Sole Features
    soleFeature1Title: 'Deri Taban',
    soleFeature1Badge: 'Klasik & Doğal',
    soleFeature1Desc: 'El yapımı hakiki deri taban; nefes alır, ayak şekline uyum sağlar, zamanla karakterlenir.',
    soleFeature1Pro1: 'Nefes alabilir ve doğal his',
    soleFeature1Pro2: 'Ayak şekline uyum sağlar',
    soleFeature1Pro3: 'Estetik ve zarif görünüm',
    soleFeature1Con1: 'Aşırı suya maruz bırakmayın',
    soleFeature2Title: 'Kauçuk Taban',
    soleFeature2Badge: 'Dayanıklı & Hava Koşullarına Uygun',
    soleFeature2Desc: 'Kaymaz kauçuk taban; yağmurlu, soğuk ve sert zeminlerde mükemmel tutuş ve koruma sağlar.',
    soleFeature2Pro1: 'Suya ve kışa dayanıklı',
    soleFeature2Pro2: 'Sert zeminlerde kaymaz güvenlik',
    soleFeature2Pro3: 'Dört mevsim kullanıma uygun',
    soleFeature3Title: 'Bakır + Topraklama',
    soleFeature3Badge: 'Grounding Etkili',
    soleFeature3Desc: 'İletken bakır detaylar sayesinde her adımda doğayla topraklama bağlantısı kurulur.',
    soleFeature3Pro1: 'Bilimsel grounding etkisi',
    soleFeature3Pro2: 'Toprağın enerjisini hissettir',
    soleFeature3Pro3: 'Stres azaltmaya katkı sağlar',
    soleCompareTitle: 'Taban Karşılaştırması',
    soleCompareName: 'Özellik',
    soleCompareWater: 'Su Direnci',
    soleCompareWinter: 'Kış Uyumu',
    soleCompareGrip: 'Zemin Tutuşu',
    soleCompareBreath: 'Nefes Alabilirlik',
    soleCompareGrounding: 'Topraklama',
  },

  barefootHealth: {
    badgeLabel: 'Podiyatrist Onaylı',
    verified: 'Bilimsel Araştırma',
    title: 'Barefoot\'un Sağlık Avantajları',
    subtitle: 'Podiyatrist tavsiyeli barefoot teknolojisi — ayak sağlığınız için en doğal tercih.',
    more: 'daha fazla',
    cta: 'Tüm Sağlık Avantajlarını Gör',
    popupTitle: 'Barefoot Teknolojisinin Sağlık Avantajları',
    popupSubtitle: 'Bilim ile doğanın buluşması — ayak sağlığınız için kanıtlanmış faydalar',
    podiatrist: 'Podiyatrist',
    benefitsTitle: '6 Temel Sağlık Avantajı',
    benefits: [
      'Doğal Parmak Yayılması',
      'Gelişmiş Denge & Koordinasyon',
      'Kas Güçlenmesi',
      'Eklem Sağlığı',
      'Doğal Yürüyüş Postürü',
      'Zemin Adaptasyonu',
    ],
    benefitDescs: [
      'Geniş parmak kutusu, parmakların anatomik pozisyonunda doğal olarak yayılmasını sağlar.',
      'Minimal taban propriyosepsiyonu artırarak denge ve koordinasyonu iyileştirir.',
      'Ayak, baldır ve kalça kasları daha doğal çalışarak zamanla güçlenir.',
      'Eklem üzerindeki baskı azalarak uzun vadede diz ve kalça sağlığını destekler.',
      'Topuk darbesi azalır, doğal ön ayak yürüyüşü desteklenir.',
      'Zemin hissi artar, beyin-ayak bağlantısı gelişir.',
    ],
    doctorQuote: 'Barefoot ayakkabılar, ayak için anatomik olarak en uygun seçenekler arasında yer almaktadır. Geniş parmak kutusu parmakların doğal yayılmasını sağlarken minimal taban propriyosepsiyonu artırır.',
    warningsTitle: 'Geleneksel Ayakkabının Riskleri',
    warnings: [
      'Parmak sıkışması bunyon ve çekiç parmağa yol açabilir',
      'Yüksek topuklar vücudun ağırlık merkezini bozar',
      'Aşırı destek ayak kaslarını zayıflatır',
      'Dar parmak kutusu sinir sıkışmasına neden olabilir',
      'Kalın taban zemin duyusal geri bildirimini engeller',
      'Uzun vadede yürüyüş bozuklukları gelişebilir',
    ],
    anatomyTitle: 'Barefoot vs Geleneksel: Anatomik Karşılaştırma',
    anatomyBarefoot: 'Barefoot — Doğal & Sağlıklı',
    anatomyTraditional: 'Geleneksel — Sıkışma & Baskı',
  },

  productFAQ: {
    badge: 'Ürün S.S.S.',
    title: 'Sıkça Sorulan Sorular',
    subtitle: 'Bu ürüne özel en çok sorulan sorular ve cevapları',
    q1: 'Hangi bedeni almalıyım?',
    a1: 'Beden rehberimizi kullanmanızı öneririz. Seçim sayfasındaki US numara tablosundan ölçünüze göre seçim yapabilirsiniz. İki beden arasındaysanız büyük olanı seçin — ücretsiz iade ve değişim hakkınız mevcuttur.',
    q2: 'Ürün hangi malzemeden üretiliyor?',
    a2: 'Ürünlerimiz GOTS sertifikalı organik keten ve pamuktan üretilmektedir. Kimyasal boyar madde kullanılmaz; tamamen doğal, hipoalerjenik ve sürdürülebilir kaynaklardan temin edilir.',
    q3: 'Kargo ne zaman gelir?',
    a3: 'Siparişiniz 1-2 iş günü içinde hazırlanır. Türkiye genelinde 3-5 iş günü, uluslararası siparişler için 6-12 iş günü içinde teslim edilir. Tüm siparişlerde ücretsiz kargo geçerlidir.',
    q4: 'İade edebilir miyim?',
    a4: 'Teslim aldığınız tarihten itibaren 30 gün içinde ücretsiz iade edebilirsiniz. İade kargo ücreti tarafımızca karşılanmaktadır. Ürün kullanılmamış, etiketi sökülmemiş ve orijinal ambalajında olmalıdır.',
    q5: 'Hangi tabanı seçmeliyim?',
    a5: 'Günlük ve yaz kullanımı için Deri Taban şık ve doğal bir seçimdir. Yağmurlu, kışlık veya sert zeminler için Kauçuk Taban daha dayanıklıdır. Doğayla topraklama etkisi isteyenler için Bakır + Topraklama tabanı önerilir.',
    q6: 'Geniş mi dar mı kalıp almalıyım?',
    a6: 'Emin değilseniz Geniş Kalıp\'ı öneririz — vücuda serbestçe oturur, herkese uyum sağlar ve uzun süre konfortlu kalır. Fitted ve belirgin siluet isteyenler için Dar Kalıp tercih edilebilir.',
    q7: 'Ürünü nasıl temizleyip bakım yapmalıyım?',
    a7: '30°C\'de hassas programda yıkayabilirsiniz. Organik keten kumaşta hafif kırışıklık normaldir — buharlı ütüleyin. Klorsuz, oksijen bazlı deterjan kullanın ve asarak gölgede kurutun.',
    q8: 'Kişiselleştirme yaptırabilir miyim?',
    a8: 'Evet! Ürüne özel isim, mesaj veya renk tercihi ekleyebilirsiniz. Hediye paketi ile kurdele ve tebrik kartı seçeneği de mevcuttur. Ürün sayfasındaki "Kişiselleştirme & Hediye Paketi" butonunu kullanın.',
    ctaTitle: 'Başka sorunuz mu var?',
    ctaDesc: 'Canlı destek ekibimiz 7/24 yardımcı olmaya hazır.',
    ctaBtn: 'Canlı Destek',
  },
  relatedProducts: {
    title: 'Benzer Ürünler',
    subtitle: 'Aynı kategoriden beğenebileceğin alternatifler',
    freeShipping: 'Ücretsiz Kargo',
    sold: 'satış',
    viewProduct: 'Ürünü İncele',
    viewAll: 'Tüm ürünleri gör',
  },
  alsoBought: {
    title: 'Bu Ürünü Alanlar Şunları da Aldı',
    subtitle: 'Bu ürünü satın alan müşterilerin en çok tercih ettiği ürünler',
    liveBadge: 'Şu an trend',
    trending: 'Trend',
    soldTogether: 'kişi birlikte aldı',
    quickView: 'Hızlı Görüntüle',
    quickViewLabel: 'Hızlı Önizleme',
    added: 'Eklendi',
    trustSecure: 'Güvenli Ödeme',
    trustShipping: 'Ücretsiz Kargo',
    trustReturn: '30 Gün İade',
    qvDiscount: 'İndirim',
    qvSave: 'Tasarruf',
    qvReviews: 'yorum',
    qvAddToCart: 'Sepete Ekle',
    qvGoToProduct: 'Ürün Sayfasına Git',
    qvNote: 'Tüm seçenekler ve detaylar için ürün sayfasını ziyaret edebilirsiniz.',
  },
  igPopup: {
    title: '🎉 %60 İndirim Kazan',
    description: 'Instagram\'da bizi takip et, 3 gönderiyi beğen, 3 gönderiye yorum yap ve DM\'den "CODE" yaz — indirimin senindir!',
    step1: 'Bizi takip et: @zenciv.store',
    step2: '3 gönderiyi beğen',
    step3: '3 gönderiye yorum yap',
    step4: 'DM\'den "CODE" yaz',
    usernamePlaceholder: 'Instagram kullanıcı adın',
    emailPlaceholder: 'E-posta adresin',
    goToInstagram: 'Instagram\'a Git',
    completed: 'Tamamladım — DM Gönder',
    sending: 'Gönderiliyor...',
    trustNote: 'Spam göndermeyiz. Sadece indirim ve güncellemeler.',
    errorInstagram: 'Instagram kullanıcı adı gereklidir.',
    errorEmail: 'Geçerli bir e-posta adresi girin.',
    successTitle: 'Harika, teşekkürler!',
    successText: 'Adımları tamamladıktan sonra sana DM\'den %60 indirim kodunu göndereceğiz.',
    successDiscount: '%60 İndirim Kodu DM\'le Gelecek',
    sendDM: 'DM Gönder',
    continueShopping: 'Alışverişe Devam Et',
  },
  measureGuide: {
    btnLabel: 'Ölçüm Rehberi',
    title: 'Ayak Ölçüm Rehberi',
    subtitle: 'Çıplak ayak ölçümü — cm cinsinden',
    diagramLabel: 'Ölçüm Diyagramı',
    lengthLabel: 'UZUNLUK',
    widthLabel: 'GENİŞLİK',
    toeWidthLabel: 'PRM GENişLİĞİ',
    example: 'Örnek:',
    stepsTitle: 'Nasıl Ölçülür?',
    step1Title: 'Beyaz kağıt koyun',
    step1Desc: 'Düz bir zemine beyaz bir kağıt serin. Çorabınızı çıkarın ve kağıdın üzerine dikin.',
    step2Title: 'Ayağınızı çizin',
    step2Desc: 'Kalemi dik tutarak ayağınızın etrafını dikkatlice çizin. Topuk ve en uzun parmak dahil.',
    step3Title: 'Uzunluğu ölçün',
    step3Desc: 'Topuk ucundan en uzun parmak ucuna kadar olan mesafeyi santimetre cinsinden ölçün.',
    step4Title: 'Genişliği ölçün',
    step4Desc: 'Ayağın en geniş noktasından (başparmak boğumu hizası) ölçüm yapın.',
    tipLabel: 'İpucu:',
    tip: 'İki ayağınız farklı büyüklükte ise büyük olanı esas alın. Ölçümünüzü kişiselleştirme kutusuna "24.5 CM × 9 CM" formatında girin.',
    gotIt: 'Anladım, Kapat',
  },

  categories: {
    'women-clothing': 'Kadın Giyim',
    'women-shoes': 'Kadın Ayakkabı',
    'women-slippers': 'Kadın Terlik',
    'women-sandals': 'Kadın Sandalet',
    'women-combo': 'Kadın Kombin',
    'women-clothing-tshirt': 'Kadın T-Shirt',
    'women-clothing-pants': 'Kadın Pantolon',
    'women-clothing-dress': 'Kadın Elbise',
    'women-clothing-kimono': 'Kadın Kimono',
    'women-clothing-crop': 'Kadın Crop Top',
    'women-clothing-shirt': 'Kadın Gömlek',
    'women-clothing-skirt': 'Kadın Etek',
    'women-clothing-shorts': 'Kadın Şort',
    'women-clothing-set': 'Kadın Takım',
    'women-clothing-suit': 'Kadın Takım Elbise',
    'men-clothing': 'Erkek Giyim',
    'men-shoes': 'Erkek Ayakkabı',
    'men-slippers': 'Erkek Terlik',
    'men-sandals': 'Erkek Sandalet',
    'men-combo': 'Erkek Kombin',
    'men-clothing-tshirt': 'Erkek T-Shirt',
    'men-clothing-pants': 'Erkek Pantolon',
    'men-clothing-shirt': 'Erkek Gömlek',
    'men-clothing-shorts': 'Erkek Şort',
    'men-clothing-suit': 'Erkek Takım Elbise',
    combo: 'Kombo Set',
    women: 'Kadın',
    men: 'Erkek',
    'vegan-leather': 'Vegan Deri',
    'genuine-leather': 'Gerçek Deri',
  },
};

export default common;